import { useState, useEffect, useLayoutEffect, useMemo, useCallback, useRef } from "react";
import logo from './logo.png';
import mark from './mark.png';
import wordmark from './wordmark.png';
import { MdSpaceDashboard, MdManageAccounts, MdAccountBalance, MdContactMail, MdCalendarMonth , MdCurrencyExchange , MdListAlt ,
         MdTableChart, MdSettings, MdSchedule, MdPayments, MdDraw, MdDescription, MdAdminPanelSettings, MdHistory, MdAssessment, MdMoneyOff, MdNotes, MdChevronLeft, MdChevronRight, MdTrendingUp, MdShare, MdInsights, MdGroups, MdMarkEmailUnread, MdEventRepeat, MdMenuBook, MdFindInPage, MdPlaylistAddCheck, MdBusiness, MdPersonAdd } from "react-icons/md";
import { BsBarChartFill, BsDatabaseFillDown  } from "react-icons/bs";

// ── Shared modules (extracted from this file) ──
import { B, ROLES, alertsFor, alertChip } from "./shared/theme";
import { fmt, fmtR, fmtPerc, fmtPhone, fmtDate, now, wfDate, localFilter, exportCSV, setExportLogger } from "./shared/format";
import { AuthContext, makeApi } from "./shared/api";
import { usePagination, useSortable, useForm } from "./shared/hooks";
import { Icon, RiskBadge, FInputNum, Badge, RoleBadge, Th, Td, ThNum, TdNum, Card, ReadOnlyForm, StatCard,
         Spinner, ErrorMsg, Breadcrumb, SectionHeader, SearchBar, STh, Pagination, Btn, TabBtn, Modal,
         Field, FInput, FSelect, Confirm, useEscape } from "./shared/ui";
import { LoginPage, DocUploader, AuditViewer, NotifCenter } from "./shared/components";
import { UsagePage } from "./apps/upm/pages/UsagePage";
import { org } from "./shared/org";
import { APPS, DEFAULT_PAGE, appAllowed } from "./apps/registry";
import { CollateralHome } from "./apps/collateral/CollateralHome";
import { BorrowingBaseDetail } from "./apps/collateral/BorrowingBaseDetail";
import { CollateralDashboard } from "./apps/collateral/CollateralDashboard";
import { CollateralPortfolio } from "./apps/collateral/CollateralPortfolio";
import { CollateralInsights } from "./apps/collateral/CollateralInsights";
import { AccountCreateNotice } from "./apps/upm/forms/AccountCreateNotice";
import { AppContext } from "./shared/appContext";
import { runDelete } from "./shared/deleteFlow";
import { AllCovenantExceptionsPage } from "./apps/upm/pages/CovenantExceptionsPage";
import { AllTermsPage } from "./apps/upm/pages/AllTermsPage";
import { UserManagementPage } from "./apps/upm/pages/UserManagementPage";
import { ClientPortalPage } from "./apps/upm/pages/ClientPortalPage";
import { AllDrawsPage } from "./apps/upm/pages/AllDrawsPage";
import { AllSpmtsPage } from "./apps/upm/pages/AllSpmtsPage";
import { AllACHCollectionsPage } from "./apps/upm/pages/AllACHCollectionsPage";
import { AllRpmtsPage } from "./apps/upm/pages/AllRpmtsPage";
import { AllParticipantSpmtsPage } from "./apps/upm/pages/AllParticipantSpmtsPage";
import { AllParticipantPmtsPage } from "./apps/upm/pages/AllParticipantPmtsPage";
import { AllContactsPage } from "./apps/upm/pages/AllContactsPage";
import { AllBankAccountsPage } from "./apps/upm/pages/AllBankAccountsPage";
import { AllBorrowersGuarantorsPage } from "./apps/upm/pages/AllBorrowersGuarantorsPage";
import { AllLegalEventsPage } from "./apps/upm/pages/AllLegalEventsPage";
import { UCCRegisterPage } from "./apps/upm/pages/UCCRegisterPage";
import { UCCSearchesPage } from "./apps/upm/pages/UCCSearchesPage";
import { ActionCenterPage, loadActionData, actionCounts } from "./apps/upm/pages/ActionCenterPage";
import { TaxMonitoringPage } from "./apps/upm/pages/TaxMonitoringPage";
import { MCAMonitorPage } from "./apps/upm/pages/MCAMonitorPage";
import { NewsMonitorPage } from "./apps/upm/pages/NewsMonitorPage";
import { BankActivityPage } from "./apps/upm/pages/BankActivityPage";
import { MCACompaniesPage } from "./apps/upm/pages/MCACompaniesPage";
import { TaxGuardMatchingPage } from "./apps/upm/pages/TaxGuardMatchingPage";
import { NotesPanel } from "./apps/upm/components/NotesPanel";
import { LoanFundsTab } from "./apps/upm/components/LoanFundsTab";
import { CollateralSpreadsheet } from "./apps/upm/components/CollateralSpreadsheet";
import { CollateralTab } from "./apps/upm/components/CollateralTab";
import { ExceptionForm } from "./apps/upm/components/ExceptionForm";
import { ExceptionsTable } from "./apps/upm/components/ExceptionsTable";
import { ExceptionsPanel } from "./apps/upm/components/ExceptionsPanel";
import { CovenantTab } from "./apps/upm/components/CovenantTab";
import { AccountForm } from "./apps/upm/forms/AccountForm";
import { LoanForm } from "./apps/upm/forms/LoanForm";
import { TermsForm } from "./apps/upm/forms/TermsForm";
import { SPmtForm } from "./apps/upm/forms/SPmtForm";
import { RPmtForm } from "./apps/upm/forms/RPmtForm";
import { ContactForm } from "./apps/upm/forms/ContactForm";
import { DrawForm } from "./apps/upm/forms/DrawForm";
import { ACHCollectionForm } from "./apps/upm/forms/ACHCollectionForm";
import { SalesDashboardPage } from "./apps/sales/pages/SalesDashboardPage";
import { LeadsPage } from "./apps/sales/pages/LeadsPage";
import { OpportunitiesPage } from "./apps/sales/pages/OpportunitiesPage";
import { SalesAccountsPage } from "./apps/sales/pages/SalesAccountsPage";
import { SalesAccountPage } from "./apps/sales/pages/SalesAccountPage";
import { SalesContactsPage } from "./apps/sales/pages/SalesContactsPage";
import { EmailTriagePage } from "./apps/sales/pages/EmailTriagePage";
import { FollowUpsPage } from "./apps/sales/pages/FollowUpsPage";
import { MailCaptureAdminPage } from "./apps/sales/pages/MailCaptureAdminPage";
import { IntegrationNotificationsPage } from "./apps/upm/pages/IntegrationNotificationsPage";
import { IntegrationClientMailPage } from "./apps/upm/pages/IntegrationClientMailPage";
import { IntegrationCSCPage } from "./apps/upm/pages/IntegrationCSCPage";
import { IntegrationSerperPage } from "./apps/upm/pages/IntegrationSerperPage";
import { IntegrationTaxGuardPage } from "./apps/upm/pages/IntegrationTaxGuardPage";
import { ReferralSourcesPage } from "./apps/sales/pages/ReferralSourcesPage";
import { ReferralSourcePage } from "./apps/sales/pages/ReferralSourcePage";
import { ReferralSourceForm } from "./apps/sales/forms/ReferralSourceForm";
import { SalesAnalyticsPage } from "./apps/sales/pages/SalesAnalyticsPage";
import { OpportunitySourcesPage } from "./apps/sales/pages/OpportunitySourcesPage";
import { FalloutAnalysisPage } from "./apps/sales/pages/FalloutAnalysisPage";
import { EmployeeSummaryPage } from "./apps/sales/pages/EmployeeSummaryPage";
import { MonthlyActivityPage } from "./apps/sales/pages/MonthlyActivityPage";
import { LeadsByMonthPage } from "./apps/sales/pages/LeadsByMonthPage";
import { LeadToOpportunityPage } from "./apps/sales/pages/LeadToOpportunityPage";
import { OpportunityToTermSheetPage } from "./apps/sales/pages/OpportunityToTermSheetPage";
import { TermSheetToFundingPage } from "./apps/sales/pages/TermSheetToFundingPage";
import { OpportunityByMonthPage } from "./apps/sales/pages/OpportunityByMonthPage";
import { TSSignedToFundingPage } from "./apps/sales/pages/TSSignedToFundingPage";
import { OppTSByMonthPage } from "./apps/sales/pages/OppTSByMonthPage";
import { FalloutDetailPage } from "./apps/sales/pages/FalloutDetailPage";
import { LeadForm } from "./apps/sales/forms/LeadForm";
import { OpportunityForm } from "./apps/sales/forms/OpportunityForm";
import { BankAccountForm } from "./apps/upm/forms/BankAccountForm";
import { BorrowerGuarantorForm } from "./apps/upm/forms/BorrowerGuarantorForm";
import { LegalEventForm } from "./apps/upm/forms/LegalEventForm";
import { ChargeOffForm } from "./apps/upm/forms/ChargeOffForm";
import { RiskRatingForm } from "./apps/upm/forms/RiskRatingForm";
import { NoteForm } from "./apps/upm/forms/NoteForm";
import { FundForm } from "./apps/upm/forms/FundForm";
import { LoanFundForm } from "./apps/upm/forms/LoanFundForm";
import { ChecklistItemForm } from "./apps/upm/forms/ChecklistItemForm";
import { ChecklistCatalogForm } from "./apps/upm/forms/ChecklistCatalogForm";
import { ParticipantPmtForm } from "./apps/upm/forms/ParticipantPmtForm";
import { ParticipantSPmtForm } from "./apps/upm/forms/ParticipantSPmtForm";
import { RateForm } from "./apps/upm/forms/RateForm";
import { ForwardRateForm } from "./apps/upm/forms/ForwardRateForm";
import { PmtPostingRuleForm } from "./apps/upm/forms/PmtPostingRuleForm";
import { BIDashboardForm } from "./apps/upm/forms/BIDashboardForm";
import { CovenantForm } from "./apps/upm/forms/CovenantForm";
import { CovenantCatalogForm } from "./apps/upm/forms/CovenantCatalogForm";
import { CovenantCalendarForm } from "./apps/upm/forms/CovenantCalendarForm";
import { AllChargeOffsPage } from "./apps/upm/pages/AllChargeOffsPage";
import { AllRiskRatingsPage } from "./apps/upm/pages/AllRiskRatingsPage";
import { AllFundsPage } from "./apps/upm/pages/AllFundsPage";
import { AllForwardRatesPage } from "./apps/upm/pages/AllForwardRatesPage";
import { AllRatesPage } from "./apps/upm/pages/AllRatesPage";
import { AllPmtPostingRulesPage } from "./apps/upm/pages/AllPmtPostingRulesPage";
import { AllLoansPage } from "./apps/upm/pages/AllLoansPage";
import { AllNotesPage } from "./apps/upm/pages/AllNotesPage";
import { AllChecklistPage } from "./apps/upm/pages/AllChecklistPage";
import { ChecklistCatalogPage } from "./apps/upm/pages/ChecklistCatalogPage";
import { ChecklistMappingPage } from "./apps/upm/pages/ChecklistMappingPage";
import { PowerBIDashboardsPage } from "./apps/upm/pages/PowerBIDashboardsPage";
import { CollateralAnalyticsPage } from "./apps/upm/pages/CollateralAnalyticsPage";
import { DrawForecastPage } from "./apps/upm/pages/DrawForecastPage";
import { StratificationPage } from "./apps/upm/pages/StratificationPage";
import { PortfolioBalancePage } from "./apps/upm/pages/PortfolioBalancePage";
import { PortfolioPerformancePage } from "./apps/upm/pages/PortfolioPerformancePage";
import { ForwardCurvesPage } from "./apps/upm/pages/ForwardCurvesPage";
import { IndustryClosingsPage } from "./apps/upm/pages/IndustryClosingsPage";
import { BankTransactionsPage } from "./apps/upm/pages/BankTransactionsPage";
import { BankImportPage } from "./apps/upm/pages/BankImportPage";
import { CovenantCatalogPage } from "./apps/upm/pages/CovenantCatalogPage";
import { CovenantsPage } from "./apps/upm/pages/CovenantsPage";
import { CovenantCalendarPage } from "./apps/upm/pages/CovenantCalendarPage";
import { InterestStatementBatchPage } from "./apps/upm/pages/InterestStatementBatchPage";
import { PublishStatementsPage } from "./apps/upm/pages/PublishStatementsPage";
import { ClientInvoiceNoticesPage } from "./apps/upm/pages/ClientInvoiceNoticesPage";
import { BankAccountMappingPage } from "./apps/upm/pages/BankAccountMappingPage";
import { ClientBankDetailPage } from "./apps/upm/pages/ClientBankDetailPage";
import { DataModelPage } from "./apps/upm/pages/DataModelPage";
import { InvoiceBatchPage } from "./apps/upm/pages/InvoiceBatchPage";
import { UpdateScheduledPaymentsPage } from "./apps/upm/pages/UpdateScheduledPaymentsPage";
import { InterestStatementModal } from "./apps/upm/pages/InterestStatementModal";
import { InvoiceModal } from "./apps/upm/pages/InvoiceModal";
import { ReportBuilderPage } from "./apps/upm/pages/ReportBuilderPage";
import { BIDashboardPage } from "./apps/upm/pages/BIDashboardPage";
import { SubscribeModal } from "./apps/upm/pages/SubscribeModal";
import { CovenantCalendarVisual } from "./apps/upm/pages/CovenantCalendarVisual";
import { SPmtPage } from "./apps/upm/pages/SPmtPage";
import { AccountsPage } from "./apps/upm/pages/AccountsPage";
import { DashboardPage } from "./apps/upm/pages/DashboardPage";
import { OverduePaymentsPage } from "./apps/upm/pages/OverduePaymentsPage";
import { OwedPaymentsPage } from "./apps/upm/pages/OwedPaymentsPage";
import { LoanPage } from "./apps/upm/pages/LoanPage";
import { AccountPage } from "./apps/upm/pages/AccountPage";


// ── Hash-based deep links ────────────────────────────────────────────────
// Navigation lives in React state (`app` + `view`), not the URL — so links
// can't be right-click-opened and the back button has nothing to pop. These
// helpers mirror that state into the URL hash (e.g. #/upm/loan?loanid=42) so
// anchors become real, shareable, history-aware links, WITHOUT swapping in a
// full router. Only page-level identity is encoded; transient UI (the open
// tab within a page, modals, filters) is intentionally left out of the URL.
const serializeView = (app, view) => {
  const { page, ...params } = view || {};
  const qs = Object.entries(params)
    .filter(([, v]) => v != null && v !== "" && (typeof v === "string" || typeof v === "number" || typeof v === "boolean"))
    .map(([k, v]) => encodeURIComponent(k) + "=" + encodeURIComponent(v))
    .join("&");
  return "#/" + encodeURIComponent(app || "upm") + "/" + encodeURIComponent(page || "") + (qs ? "?" + qs : "");
};

// Record pages that open in their own chromeless window instead of replacing
// the list you were working through. Adding a page here is the whole change --
// every list already routes through navClick/rowNav, so they all pick it up at
// once rather than each list growing its own link behavior.
const SLIM_PAGES = new Set(["referral-source", "sales-account"]);

// The onboarding manual for each app, served as a static file by the app itself
// (public/*.html) rather than linked somewhere external — a link to a document
// hosted elsewhere is one expired share away from being dead on somebody's
// first day. An app with no entry here simply shows no link.
// NO LONGER A PLAIN URL. The guides used to be static files under public/,
// which meant anyone with the address could read them signed out. They are now
// served by /api/getGuide, behind the same requireUser as everything else.
//
// That has one consequence worth stating: this app's token travels in a custom
// header, not a cookie, so a normal <a href> would arrive at the endpoint with
// no credentials and be refused. The guide therefore has to be FETCHED and then
// shown, which is what openGuide below does.
const FIELD_GUIDES = {
  sales:      { name: "sales",      label: "Field Guide" },
  upm:        { name: "portfolio",  label: "Field Guide" },
  collateral: { name: "collateral", label: "Field Guide" },
};

// Fetches the guide with the caller's own credentials and shows it in a new
// tab from a blob URL.
//
// The tab's address is blob:… rather than a path, which is a fair trade and
// arguably the point: there is no longer a URL anybody can paste to somebody
// without an account. A blob URL is origin-scoped and dies with the tab.
//
// The window is opened BEFORE the fetch, synchronously, because a popup opened
// from an await is opened by a timer as far as the browser is concerned and
// gets blocked. It is opened blank and then written into.
const openGuide = async (token, name, label) => {
  const w = window.open("", "_blank");
  if (w) {
    w.document.write('<!doctype html><title>' + label
      + '</title><body style="font:14px system-ui;padding:32px;color:#555">Loading\u2026</body>');
    w.document.close();
  }
  try {
    const res = await fetch("/api/getGuide?name=" + encodeURIComponent(name), {
      headers: token ? { "x-ace-token": token, "Authorization": "Bearer " + token } : {},
      cache: "no-store",
    });
    if (!res.ok) throw new Error(res.status === 401
      ? "Your session has expired — sign in again and reopen the guide."
      : "The guide could not be loaded (" + res.status + ").");
    const html = await res.text();
    const url = URL.createObjectURL(new Blob([html], { type: "text/html" }));
    if (w) w.location.replace(url); else window.location.assign(url);
    // Released on a timer rather than immediately: revoking it before the tab
    // has finished loading leaves a blank page with no error anywhere.
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    if (w) {
      w.document.body.textContent = e.message;
    } else {
      // Popup blocked AND the fetch failed — say something rather than nothing.
      // eslint-disable-next-line no-alert
      alert(e.message);
    }
  }
};

const parseHash = (hash) => {
  if (!hash) return null;
  const raw = hash.replace(/^#\/?/, "");
  if (!raw) return null;
  const qIdx = raw.indexOf("?");
  const path = qIdx >= 0 ? raw.slice(0, qIdx) : raw;
  const query = qIdx >= 0 ? raw.slice(qIdx + 1) : "";
  const slash = path.indexOf("/");
  if (slash < 0) return null;
  const app = decodeURIComponent(path.slice(0, slash));
  const page = decodeURIComponent(path.slice(slash + 1));
  if (!app || !page) return null;
  const params = {};
  if (query) query.split("&").forEach(pair => {
    if (!pair) return;
    const eq = pair.indexOf("=");
    const k = decodeURIComponent(eq >= 0 ? pair.slice(0, eq) : pair);
    const v = eq >= 0 ? decodeURIComponent(pair.slice(eq + 1)) : "";
    if (k) params[k] = v;
  });
  return { app, view: { page, ...params } };
};

export default function App() {
  const [authState, setAuthState] = useState({ user:null, token:null, loading:true, denied:false });
  const [view, setView] = useState(() => parseHash(window.location.hash)?.view || { page:"dashboard" });
  const [tab, setTab] = useState("overview");
  const [modal, setModal] = useState(null);
  const [confirm, setConfirm] = useState(null);
  const [notifOpen, setNotifOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  // Admin "view as user" (testing). impersonateUser holds the picked Users row.
  const [impersonateUser, setImpersonateUser] = useState(null);
  const [impersonatePicker, setImpersonatePicker] = useState(false);
  // Escape closes these too (shared/escape: the top popup first). The header
  // menus close together, the way a click elsewhere closes them.
  useEscape(impersonatePicker ? () => setImpersonatePicker(false) : null);
  useEscape(notifOpen || userMenuOpen ? () => { setNotifOpen(false); setUserMenuOpen(false); } : null);
  const [impUsers, setImpUsers] = useState([]);
  const [impQuery, setImpQuery] = useState("");
  const [userPhoto, setUserPhoto] = useState(null);
  const [notifs, setNotifs] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [navOpen, setNavOpen] = useState({ tables:false, admin:false, monitoring:false });

  // ── Keep the sidebar where you scrolled it ──
  // NavItem / NavChild / NavGroup are declared inside App, so every render
  // hands React new component types and it rebuilds the whole sidebar. The
  // scrolling div survives, but its content is torn out and put back, and the
  // browser drops the scroll position — so opening Administrative at the bottom
  // of the list threw you back to the top. The position is remembered on every
  // scroll and put back after every render, before the browser paints.
  const navScrollRef = useRef(null);
  const navScrollTop = useRef(0);
  useLayoutEffect(() => {
    const el = navScrollRef.current;
    if (el && el.scrollTop !== navScrollTop.current) el.scrollTop = navScrollTop.current;
  });
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [app, setApp] = useState(() => parseHash(window.location.hash)?.app || "upm");
  const replaceNextRef = useRef(false);   // set by go({replace:true}) to swap history instead of push
  const lastKeyRef = useRef(null);        // last hash we wrote — guards the state↔URL sync from looping

  // ── Session expiry ────────────────────────────────────────────────────────
  // authState is seeded ONCE at mount from /.auth/me. The Static Web Apps auth
  // cookie behind it expires on its own schedule (~8h, not something we
  // control), so without this the shell keeps rendering as signed-in while
  // every /api call quietly 401s — the "logged in but nothing loads" state.
  // Any 401 now flips sessionExpired, which shows a notice and bounces the
  // user through a real sign-in.
  const [sessionExpired, setSessionExpired] = useState(false);
  // Ref mirror so the (stable) 401 callback can read live auth without being
  // rebuilt on every render.
  const authRef = useRef(authState); authRef.current = authState;
  const expiredRef = useRef(false);
  const probingRef = useRef(false);
  const onUnauthorized = useCallback(async (info) => {
    const a = authRef.current;
    // Ignore 401s from before we have a session — startup noise, not an expiry.
    if (a.loading || !a.user || expiredRef.current) return;

    // A bare 401 is NOT proof the session died. A loader holding a stale
    // closure (see loadNotifs/loadBiDashboards below) can fire a request with
    // no credentials attached and draw the exact same 401 from requireUser.
    // Acting on that wipes a perfectly good session and bounces the user
    // straight back to the login screen — a sign-in loop. So: confirm first,
    // and only ever invalidate on evidence.
    if (probingRef.current) return;      // one probe at a time; ~13 parallel
    probingRef.current = true;           // GETs per page all land here at once
    try {
      if (a.user.authType === "aad") {
        // Cookie-based — the browser attaches it to every request whether or
        // not our closure is stale, so /.auth/me is the authority on liveness.
        try {
          const r = await fetch("/.auth/me", { cache:"no-store" });
          const d = await r.json();
          if (d && d.clientPrincipal && d.clientPrincipal.userId) return;
        } catch (_) {
          return;   // can't reach the auth endpoint — network blip, not expiry
        }
      } else if (!info || !info.sentToken) {
        // Local/JWT sign-in: only a request that actually CARRIED the token and
        // still got refused tells us anything about the token.
        return;
      }
      expiredRef.current = true;
      setSessionExpired(true);
    } finally {
      probingRef.current = false;
    }
  }, []);

  // Third argument makes "Test as user" real: the id travels with every
  // request and the server scopes as that user. Without it the SPA showed
  // one identity while the API answered as another.
  const api = makeApi(() => authState.token, onUnauthorized,
    () => (impersonateUser ? impersonateUser.id : null));

  // Every Export CSV is logged (who, which page and file, how many rows, from
  // where) for Administrative → Usage → Exports. Fire and forget.
  const exportCtx = useRef({});
  exportCtx.current = { app, page: view && view.page };
  useEffect(() => {
    setExportLogger(info => {
      if (!authRef.current || !authRef.current.user) return;
      api.post("logExport", { ...info, ...exportCtx.current }).catch(() => {});
    });
    return () => setExportLogger(null);
  }, [authState.token, impersonateUser]); // eslint-disable-line react-hooks/exhaustive-deps

  // Force a genuine re-auth. For AAD we bounce through the provider with
  // post_login_redirect_uri set to the current hash, so a still-valid Microsoft
  // SSO session lands the user back on the page they were on. Local-token
  // sign-ins drop to LoginPage.
  const forceReauth = useCallback(() => {
    const a = authRef.current;
    localStorage.removeItem("ls_token");
    localStorage.removeItem("ls_user");
    localStorage.removeItem("ls_last_activity");
    if (a.user && a.user.authType === "aad") {
      const back = window.location.pathname + window.location.search + window.location.hash;
      window.location.href = "/.auth/login/aad?post_login_redirect_uri=" + encodeURIComponent(back);
    } else {
      setAuthState({ user:null, token:null, loading:false });
      setSessionExpired(false);
      expiredRef.current = false;
    }
  }, []);

  // Give the notice a beat to render, then re-auth.
  useEffect(() => {
    if (!sessionExpired) return;
    const t = setTimeout(forceReauth, 1800);
    return () => clearTimeout(t);
  }, [sessionExpired, forceReauth]);

  useEffect(()=>{
    const initAuth = async () => {
      await new Promise(res => setTimeout(res, 500));
      try {
        const adRes = await fetch("/.auth/me");
        const adData = await adRes.json();
        if (adData && adData.clientPrincipal && adData.clientPrincipal.userId) {
          const cp = adData.clientPrincipal;
          const email = cp.userDetails;
          try {
            const roleRes = await fetch("/api/getUserRole?email=" + encodeURIComponent(email));
            if (roleRes.status === 403) {
              // Not provisioned — or signed in from a network this account may
              // not be used from, in which case the reply says so.
              let why = null;
              try { const b = await roleRes.json(); if (b && b.code === "network") why = b.error; } catch (e) { /* no body */ }
              setAuthState({ user:null, token:null, loading:false, denied:true, deniedEmail:email, deniedMsg:why });
              return;
            }
        const roleData = await roleRes.json();
            setAuthState({ user:{ id:cp.userId, name:roleData.name||email, email, role:roleData.role||"Viewer",
              isbankcredviewer:!!roleData.isbankcredviewer, isunderwriter:!!roleData.isunderwriter,
              isbdo:!!roleData.isbdo,
              isbdomanager:!!roleData.isbdomanager,
              istermfunding:!!roleData.istermfunding,
              isdrawfunding:!!roleData.isdrawfunding,
              isportfoliomanager:!!roleData.isportfoliomanager,
              isaccountmanager:!!roleData.isaccountmanager,
              isservicer:!!roleData.isservicer,
              authType:"aad" }, token:null, loading:false });
            return;
          } catch(e) {}
          setAuthState({ user:{ id:cp.userId, name:email, email, role:"Viewer", authType:"aad" }, token:null, loading:false });
          return;
        }
      } catch(e) {}

      const token = localStorage.getItem("ls_token");
      const userStr = localStorage.getItem("ls_user");
      if (token && userStr) {
        try { setAuthState({ user:JSON.parse(userStr), token, loading:false }); return; } catch(e) {}
      }
      setAuthState({ user:null, token:null, loading:false });
    };
    initAuth();
  },[]);

  const handleLogin = (user, token) => setAuthState({ user, token, loading:false });
  const handleLogout = async () => {
    localStorage.removeItem("ls_token");
    localStorage.removeItem("ls_user");
    localStorage.removeItem("ls_last_activity");
    if (authState.user && authState.user.authType === "aad") {
      window.location.href = "/.auth/logout?post_logout_redirect_uri=/";
    } else {
      setAuthState({ user:null, token:null, loading:false });
    }
  };

  // ── Auto sign-out after 4 hours of inactivity ─────────────────────────────
  // Last-activity time is stored in localStorage (shared across tabs, survives refresh
  // and machine sleep). We re-check on an interval and whenever the tab regains focus,
  // so a laptop that slept past the limit is signed out the moment it wakes.
  const IDLE_LIMIT_MS = 4 * 60 * 60 * 1000;
  const logoutRef = useRef(null);
  logoutRef.current = handleLogout;
  useEffect(() => {
    if (!authState.user) return;
    const KEY = "ls_last_activity";
    const stamp = () => { try { localStorage.setItem(KEY, String(Date.now())); } catch(e){} };
    let last = 0;
    const onActivity = () => { const t = Date.now(); if (t - last > 30000) { last = t; stamp(); } };
    const check = () => {
      let ts = 0; try { ts = parseInt(localStorage.getItem(KEY) || "0", 10); } catch(e){}
      if (ts && Date.now() - ts > IDLE_LIMIT_MS && logoutRef.current) logoutRef.current();
    };
    stamp();  // seed on login / mount
    const events = ["mousemove","mousedown","keydown","scroll","touchstart","click"];
    events.forEach(ev => window.addEventListener(ev, onActivity, { passive:true }));
    const onVis = () => { if (document.visibilityState === "visible") check(); };
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("focus", onVis);
    const iv = setInterval(check, 60000);
    return () => {
      events.forEach(ev => window.removeEventListener(ev, onActivity));
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("focus", onVis);
      clearInterval(iv);
    };
  }, [authState.user]);

  // Dep on authState.token, NOT [] — same reason spelled out for
  // loadBiDashboards below. A []-memo captures the FIRST render's `api`, whose
  // getToken closure still reads token:null, so this fires getNotifications
  // with no Authorization header the moment a local sign-in completes → 401.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadNotifs = useCallback(async () => {
    try { setNotifs(await api.get("getNotifications")); } catch(e) {}
  },[authState.token, impersonateUser]);
  useEffect(()=>{ if(authState.user) loadNotifs(); },[authState.user, loadNotifs]);

  // ── How many addresses are waiting in Email Review ────────────────────────
  //
  // Same token dependency as loadNotifs above, for the same reason spelled out
  // there: a []-memo captures the first render's `api`, whose getToken closure
  // still reads token:null, and the request goes out unauthenticated.
  //
  // limit:1 because only `total` is wanted. getEmailActivity answers the queue
  // total from its own COUNT(*) rather than from the length of the rows it
  // returns, so one row of payload buys the true size of the backlog.
  //
  // NO CLIENT-SIDE ADMIN CHECK beyond deciding whether to show what comes back.
  // The endpoint refuses a non-administrator outright, and a second copy of
  // that rule here is exactly the kind that drifts from the one that matters.
  // A refusal leaves the count null, and null renders nothing.
  const [emailQueue, setEmailQueue] = useState(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadEmailQueue = useCallback(async () => {
    try {
      const d = await api.get("getEmailActivity", { queue: "new", limit: 1 });
      setEmailQueue(typeof (d || {}).total === "number" ? d.total : null);
    } catch (e) { setEmailQueue(null); }
    // impersonateUser too: "Test as user" must recount as that user. With the
    // token alone the badges kept the administrator's numbers (Email Review
    // showed 149 beside a page that, as the BDO, was rightly empty).
  }, [authState.token, impersonateUser]);

  // On sign-in, and whenever you move between apps. Deliberately NOT polled:
  // the number moves when mail arrives or when you clear a row, and a timer
  // would spend a query a minute to tell you nothing on almost all of them.
  useEffect(()=>{ if(authState.user) loadEmailQueue(); },[authState.user, app, loadEmailQueue]);

  // ── How many items are waiting on the four monitoring pages ─────────────
  // The Email Review badge, applied to UCC Filings, Tax Monitoring, MCA
  // Monitor and Bank Activity. One call answers all four (getMonitoringCounts),
  // each counted the way its page counts its own default view; a count the user
  // may not see, or a queue not set up yet, comes back null and shows nothing.
  // Same token dependency and same no-polling rule as loadEmailQueue above.
  const [monCounts, setMonCounts] = useState({});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadMonCounts = useCallback(async () => {
    try { setMonCounts((await api.get("getMonitoringCounts")) || {}); }
    catch (e) { setMonCounts({}); }
  }, [authState.token, impersonateUser]);
  useEffect(()=>{ if(authState.user) loadMonCounts(); },[authState.user, app, loadMonCounts]);

  // ── Action Center: its badge, and where portfolio managers land ─────────
  // The count is the Action Center's own (actionCounts over loadActionData),
  // so the badge, the Dashboard's one-line strip and the page agree. Loaded on
  // sign-in and when you leave the page; the page refreshes it as it loads.
  // `role` is built further down (after the early returns), so it is read
  // through a ref that is filled once it exists.
  const roleRef = useRef(null);
  const [actionCount, setActionCount] = useState(null);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const loadActionCount = useCallback(async () => {
    const r = roleRef.current;
    if (!r) return;
    try { const c = actionCounts(await loadActionData(api, r)); setActionCount(c ? c.total : null); }
    catch (e) { setActionCount(null); }
  }, [authState.token, impersonateUser]);
  useEffect(()=>{ if(authState.user && app === "upm") loadActionCount(); },[authState.user, app, loadActionCount]);
  // Portfolio managers open on the Action Center; everyone else on the
  // Dashboard. Only when the app was opened plainly — a link to a page wins.
  const landedDefault = useRef(!parseHash(window.location.hash));
  useEffect(() => {
    if (!authState.user || !landedDefault.current) return;
    landedDefault.current = false;
    const r = roleRef.current;
    if (r && r.isportfoliomanager && app === "upm") setView(v => (v && v.page === "dashboard" ? { page: "action-center" } : v));
  }, [authState.user]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Page-view tracking, for Administrative → Usage ──────────────────────
  // One entry per screen visit: app, page route, account (if any), when, and
  // how long it stayed open. Time only counts while the tab is visible. Views
  // queue in memory and go to api/logPageViews every 30 seconds, and once more
  // (keepalive) when the tab is hidden or closed. Nothing is recorded while
  // "Test as user" is on — the server refuses those too.
  const pvQueue = useRef([]);
  const pvCurrent = useRef(null);      // { app, page, accountid, startedat, ms, since }
  const pvToken = useRef(null);
  pvToken.current = authState.token;
  const pvClose = () => {
    const c = pvCurrent.current;
    if (!c) return;
    const ms = c.ms + (c.since ? Date.now() - c.since : 0);
    pvQueue.current.push({ app: c.app, page: c.page, accountid: c.accountid, startedat: c.startedat, seconds: Math.round(ms / 1000) });
    pvCurrent.current = null;
  };
  const pvFlush = (keepalive) => {
    const views = pvQueue.current.splice(0, 50);
    if (!views.length) return;
    if (keepalive) {
      const h = { "Content-Type": "application/json" };
      if (pvToken.current) { h["x-ace-token"] = pvToken.current; h.Authorization = "Bearer " + pvToken.current; }
      try { fetch("/api/logPageViews", { method: "POST", headers: h, body: JSON.stringify({ views }), keepalive: true }).catch(() => {}); } catch (e) {}
    } else {
      api.post("logPageViews", { views }).catch(() => {});
    }
  };
  const pvTrackOn = !!authState.user && !impersonateUser;
  useEffect(() => {
    if (!pvTrackOn) { pvCurrent.current = null; return; }
    pvClose();
    pvCurrent.current = { app, page: view.page, accountid: view.accountid || null,
                          startedat: new Date().toISOString(), ms: 0,
                          since: document.visibilityState === "hidden" ? null : Date.now() };
  }, [pvTrackOn, app, view.page, view.accountid]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!pvTrackOn) return;
    const tick = setInterval(() => pvFlush(false), 30000);
    const onVis = () => {
      const c = pvCurrent.current;
      if (document.visibilityState === "hidden") {
        if (c && c.since) { c.ms += Date.now() - c.since; c.since = null; }
        // Close the visit so it is counted even if the tab never comes back.
        if (c) { pvClose(); pvCurrent.current = { ...c, startedat: new Date().toISOString(), ms: 0, since: null }; }
        pvFlush(true);
      } else if (c && !c.since) {
        c.since = Date.now();
      }
    };
    const onHide = () => { pvClose(); pvFlush(true); };
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("pagehide", onHide);
    return () => { clearInterval(tick); document.removeEventListener("visibilitychange", onVis); window.removeEventListener("pagehide", onHide); };
  }, [pvTrackOn]); // eslint-disable-line react-hooks/exhaustive-deps

  // And once more the moment you leave the queue, because that is the one time
  // the badge is certainly wrong — you just worked it.
  const wasTriageRef = useRef(false);
  useEffect(() => {
    const leaving = wasTriageRef.current && view.page !== "sales-email-triage";
    wasTriageRef.current = view.page === "sales-email-triage";
    if (leaving) loadEmailQueue();
  }, [view.page, loadEmailQueue]);

  // Likewise for the monitoring pages: leaving one you just worked refreshes
  // all four badges.
  const MON_PAGES = ["ucc-register", "ucc-searches", "tax-monitoring", "news-monitor", "mca-monitor", "bank-activity"];
  // Leaving the Action Center, or a page its cards link to, refreshes its badge.
  const ACTION_PAGES = ["action-center", ...MON_PAGES, "all-draws", "all-achcollections", "all-wftransactions", "owed-payments", "all-covenant-calendar-visual"];
  const wasActionRef = useRef(false);
  useEffect(() => {
    const on = ACTION_PAGES.includes(view.page);
    const leaving = wasActionRef.current && !on;
    wasActionRef.current = on;
    if (leaving) loadActionCount();
  }, [view.page, loadActionCount]); // eslint-disable-line react-hooks/exhaustive-deps
  // The checklist and covenant badges come from the same call, so leaving
  // those two pages refreshes it too.
  const COUNT_PAGES = [...MON_PAGES, "all-checklist", "all-covenant-calendar-visual", "all-wftransactions"];
  const wasMonRef = useRef(false);
  useEffect(() => {
    const onMon = COUNT_PAGES.includes(view.page);
    const leaving = wasMonRef.current && !onMon;
    wasMonRef.current = onMon;
    if (leaving) loadMonCounts();
  }, [view.page, loadMonCounts]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Opening a record from a link ────────────────────────────────────────
  //
  // Draws, ACH collections and risk ratings are modals, and serializeView
  // deliberately keeps modals out of the URL — so there is no draw URL. A
  // notification email has to link SOMEWHERE, though, and "go find it yourself"
  // is not a link.
  //
  // So the link names the loan page and carries the record id as a param:
  //   #/upm/loan?loanid=L17&draw=D1757000000000
  // parseHash already puts unknown params straight into `view`, so nothing there
  // needed changing; this effect is the whole feature.
  //
  // The param is CLEARED once the modal is open, with replace, so that closing
  // the modal does not immediately reopen it, and the back button does not walk
  // into a reopening loop. The loan page stays behind it either way, which is
  // the right place to land even if the record has since been deleted.
  //
  // One table, four params. Adding a fifth linkable record type is a row here
  // and nothing else — which is the point of writing it this way rather than
  // growing another ternary every time a notification needs somewhere to point.
  //
  // `scope` is which id the record hangs off. Draws, ACH collections and risk
  // ratings belong to a LOAN; a covenant calendar entry belongs to an ACCOUNT,
  // so its link lands on the account page instead.
  useEffect(() => {
    const LINKABLE = [
      { param:"draw", scope:"loanid",    endpoint:"getDraws",             modal:"draw-view",             label:"draw" },
      { param:"ach",  scope:"loanid",    endpoint:"getACHCollections",    modal:"ach-view",              label:"ACH collection" },
      { param:"risk", scope:"loanid",    endpoint:"getRiskRatings",       modal:"riskrating-view",       label:"risk rating" },
      { param:"cal",  scope:"accountid", endpoint:"getCovenantCalendar",  modal:"covenantcalendar-view", label:"calendar entry" },
    ];
    const hit = LINKABLE.find(l => view && view[l.param] && view[l.scope]);
    if (!authState.user || !hit) return;
    const wanted = String(view[hit.param]);
    let cancelled = false;

    (async () => {
      try {
        // These endpoints filter by the parent record, not by row id, so the
        // list is fetched and the one row picked out. One request, no endpoint
        // change, and it works for all of them.
        const rows = await api.get(hit.endpoint, { [hit.scope]: view[hit.scope] });
        if (cancelled) return;
        const rec = (Array.isArray(rows) ? rows : []).find(r => String(r.id) === wanted);
        if (rec) setModal({ type: hit.modal, rec, loanid: rec.loanid || view.loanid, accountid: rec.accountid || view.accountid });
        else setError(`That ${hit.label} is no longer here.`);
      } catch (e) {
        if (!cancelled) setError("Could not open that record: " + e.message);
      } finally {
        // Whether it opened or not, the param has done its job.
        if (!cancelled) {
          replaceNextRef.current = true;
          setView(v => { const { draw, ach, risk, cal, ...rest } = v; return rest; });
        }
      }
    })();

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState.user, view.draw, view.ach, view.risk, view.cal, view.loanid, view.accountid]);
  // Pull the Microsoft profile photo for AAD sign-ins (falls back to initials if none).
  useEffect(()=>{
    if (authState.user && authState.user.authType === "aad") {
      api.get("getMyPhoto").then(r => { if (r && r.photoUrl) setUserPhoto(r.photoUrl); }).catch(()=>{});
    }
  },[authState.user]);
  const [biDashboards, setBiDashboards] = useState([]);
    // Dep on authState.token (not []): `api` is rebuilt every render around the current
    // token, and a []-memo would capture the FIRST render's api (token still null) and
    // fire getPowerBIDashboards with no Authorization header → 401 under the new guards.
    // Re-binding on token change captures the live, token-carrying api.
    const loadBiDashboards = useCallback(async () => {
      try { setBiDashboards(await api.get("getPowerBIDashboards")); } catch(e) { setBiDashboards([]); }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[authState.token]);
    useEffect(()=>{ if(authState.user) loadBiDashboards(); },[authState.user, loadBiDashboards]);

  // If the active app requires a flag the user doesn't have, move them to one
  // they DO have. This used to hard-code "upm" as the fallback, which was safe
  // only while the portfolio app was open to everyone. Now that a sales-only
  // BDO can't enter it, that fallback would have bounced them straight into a
  // blocked app and left them on an empty shell.
    useEffect(() => {
      // Judge the user we are ACTING AS, not the one who signed in. Recomputed
      // from state rather than reusing `effectiveUser` below, which is declared
      // later in the render and would be in its temporal dead zone here.
      const u = impersonateUser
        ? { ...impersonateUser, role: impersonateUser.Role }
        : authState.user;
      if (!u) return;
      const a = APPS.find(x => x.id === app);
      if (a && !appAllowed(a, u)) {
        const fallback = APPS.find(x => appAllowed(x, u));
        if (fallback) {
          setApp(fallback.id);
          setView({ page: DEFAULT_PAGE[fallback.id] });
        }
      }
    }, [app, authState.user, impersonateUser]);

  // ── URL ⇆ nav-state sync (hash deep links) ──
  // 1) Establish a URL baseline on first load so back/forward always have
  //    something to parse (and the bar shows the current page immediately).
  useEffect(() => {
    const parsed = parseHash(window.location.hash);
    const key = parsed ? serializeView(parsed.app, parsed.view) : serializeView(app, view);
    lastKeyRef.current = key;
    window.history.replaceState(null, "", key);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 2) Mirror nav state → URL. PUSH on real page changes (so Back steps through
  //    pages); a go({replace:true}) call swaps the entry instead (for nav that
  //    shouldn't add a Back step). Transient UI never calls go(), so it never
  //    touches history. The lastKeyRef guard stops this from re-firing on the
  //    state change that a Back/Forward restore just caused.
  useEffect(() => {
    const key = serializeView(app, view);
    if (key === lastKeyRef.current) return;
    const replace = replaceNextRef.current;
    replaceNextRef.current = false;
    lastKeyRef.current = key;
    if (replace) window.history.replaceState(null, "", key);
    else window.history.pushState(null, "", key);
  }, [app, view]);

  // 3) Back/Forward → restore nav state from the URL. pushState/replaceState
  //    don't fire popstate, so this only runs for genuine user history moves.
  useEffect(() => {
    const onPop = () => {
      const parsed = parseHash(window.location.hash);
      if (!parsed) return;
      lastKeyRef.current = serializeView(parsed.app, parsed.view);
      setApp(parsed.app);
      setView(parsed.view);
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 4) An EXTERNAL hash change -> restore nav state from the URL.
  //    This is what makes a REUSED slim window work. window.open(url, name)
  //    aimed at a window that already exists does not reload it -- it just sets
  //    its location, and since our URLs differ only after the "#", that fires
  //    hashchange and NOT popstate. Without this listener the second record you
  //    clicked would raise the existing window and leave the FIRST record on
  //    screen: the click would look like it had done nothing at all.
  //    pushState/replaceState never fire hashchange, and lastKeyRef catches
  //    anything that slips through, so this cannot fight step 2.
  useEffect(() => {
    const onHash = () => {
      const parsed = parseHash(window.location.hash);
      if (!parsed) return;
      const key = serializeView(parsed.app, parsed.view);
      if (key === lastKeyRef.current) return;
      lastKeyRef.current = key;
      setApp(parsed.app);
      setView(parsed.view);
    };
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);




  if (authState.loading) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:B.sidebar }}>
      <div style={{ color:B.cyanMid, fontSize:14 }}>Loading...</div>
    </div>
  );

  if (authState.denied) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:B.sidebar, fontFamily:"var(--font-sans)" }}>
      <div style={{ width:420, maxWidth:"94vw", textAlign:"center" }}>
        <div style={{ marginBottom:24, display:"flex", justifyContent:"center" }}>
          <img src={logo} alt={org("name")} style={{ height:44, objectFit:"contain", filter:"brightness(0) invert(1)" }} />
        </div>
        <Card style={{ padding:32 }}>
          <div style={{ fontSize:32, marginBottom:12 }}>🔒</div>
          <div style={{ fontSize:16, fontWeight:500, marginBottom:8 }}>Access denied</div>
          <div style={{ fontSize:13, color:"var(--color-text-secondary)", marginBottom:24 }}>
            {authState.deniedMsg
              ? authState.deniedMsg
              : <>Your account <strong>{authState.deniedEmail}</strong> is not authorized to access this application. Please contact your administrator to request access.</>}
          </div>
          <button onClick={()=>{ window.location.href="/.auth/logout?post_logout_redirect_uri=/"; }} style={{ width:"100%", padding:"9px 16px", background:"none", border:"0.5px solid var(--color-border-secondary)", borderRadius:8, color:"var(--color-text-secondary)", fontSize:13, cursor:"pointer" }}>
            Sign out
          </button>
        </Card>
      </div>
    </div>
  );

  // Session died out from under us — say so plainly instead of leaving the user
  // on a shell whose pages all fail to load. The redirect fires from the effect
  // above; the button is there for anyone who doesn't want to wait.
  if (sessionExpired) return (
    <div style={{ minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center", background:B.sidebar, fontFamily:"var(--font-sans)" }}>
      <div style={{ width:420, maxWidth:"94vw", textAlign:"center" }}>
        <div style={{ marginBottom:24, display:"flex", justifyContent:"center" }}>
          <img src={logo} alt={org("name")} style={{ height:44, objectFit:"contain", filter:"brightness(0) invert(1)" }} />
        </div>
        <Card style={{ padding:32 }}>
          <div style={{ fontSize:32, marginBottom:12 }}>⏱️</div>
          <div style={{ fontSize:16, fontWeight:500, marginBottom:8 }}>Your session expired</div>
          <div style={{ fontSize:13, color:"var(--color-text-secondary)", marginBottom:24 }}>
            Signing you back in — you'll return to the page you were on.
          </div>
          <button onClick={forceReauth} style={{ width:"100%", padding:"9px 16px", background:"none", border:"0.5px solid var(--color-border-secondary)", borderRadius:8, color:"var(--color-text-secondary)", fontSize:13, cursor:"pointer" }}>
            Sign in now
          </button>
        </Card>
      </div>
    </div>
  );

  if (!authState.user) return <LoginPage onLogin={handleLogin} />;

  const currentUser = userPhoto ? { ...authState.user, photoUrl: userPhoto } : authState.user;
  // Only a REAL admin may impersonate; the testing controls gate on this, never
  // on the (possibly impersonated) role computed below.
  const realIsAdmin = currentUser.role === "Admin";
  // While an admin is "testing as" another user, the UI derives permissions and
  // app visibility from that user — and so does the SERVER, via the
  // x-impersonate-user header (see shared/api.js and api/shared/auth.js). The
  // server re-checks that the real caller is an admin before honouring it, and
  // audits every write made while impersonating with both identities.
  const effectiveUser = impersonateUser
    ? { ...impersonateUser, id: impersonateUser.id, name: impersonateUser.FullName, email: impersonateUser.Email, role: impersonateUser.Role }
    : currentUser;
  const role = { ...(ROLES[effectiveUser.role] || ROLES.Viewer),
  canViewBankCreds: !!effectiveUser.isbankcredviewer,
  // Mirrors derivePerms() in api/shared/auth.js. The client copy only decides
  // whether to OFFER the button; the endpoint re-checks before disclosing
  // anything, so the two drifting apart is a cosmetic bug, not a hole.
  canViewBankNumbers: !!(effectiveUser.isbankcredviewer || effectiveUser.isportfoliomanager || effectiveUser.isunderwriter),
  // Plaid linked accounts, balances and transactions. Mirrors canViewBankFeeds
  // in api/shared/auth.js. Deliberately NOT the same flag as the two above:
  // balances and transactions are what the money did, the numbers are how to
  // move it.
  canViewBankFeeds: !!(effectiveUser.isportfoliomanager || effectiveUser.role === "Admin"),
  // UCC Filings, Tax Monitoring and Tax Guard matching. Mirrors
  // canViewMonitoring in api/shared/auth.js: portfolio managers and admins.
  canViewMonitoring: !!(effectiveUser.isportfoliomanager || effectiveUser.role === "Admin"),
  // Full taxpayer identification numbers. Mirrors canViewTIN in
  // api/shared/auth.js — Portfolio Manager ONLY, and deliberately narrower than
  // the two bank permissions above: Admin is NOT on this list. An admin needs to
  // manage users and tables, not to read a borrower's EIN, and "Test as user"
  // is no way round it either (getTIN blocks impersonation).
  canViewTIN:       !!effectiveUser.isportfoliomanager,
  // Mirrors canExemptTaxCoverage in api/shared/auth.js. Decides whether the
  // control is OFFERED; the endpoint re-checks before recording anything.
  canExemptTaxCoverage: !!effectiveUser.isportfoliomanager,
  isunderwriter:    !!effectiveUser.isunderwriter,
  isbdo:            !!effectiveUser.isbdo,
  isbdomanager:     !!effectiveUser.isbdomanager,
  // Sales tiers, mirroring api/shared/salesScope.js. isbdo alone = own book
  // only and no export; a manager or admin sees all of sales and may export.
  canAccessSales:   !!(effectiveUser.isbdo || effectiveUser.isbdomanager || effectiveUser.role === "Admin"),
  canExportSales:   !!(effectiveUser.isbdomanager || effectiveUser.role === "Admin"),
  // Mirrors salesUnrestricted() in api/shared/salesScope.js — used by the
  // follow-ups page to decide whether to offer the "whose queue" picker.
  salesUnrestricted: !!(effectiveUser.isbdomanager || effectiveUser.role === "Admin"),
  isAdmin:          (effectiveUser.role === "Admin"),
  istermfunding:    !!effectiveUser.istermfunding ,
  isdrawfunding:    !!effectiveUser.isdrawfunding,
  isportfoliomanager:    !!effectiveUser.isportfoliomanager,
  isservicer:       !!effectiveUser.isservicer
};
  // Avatar initials, e.g. "Admin User" -> "AU"
  const initials = (currentUser.name || currentUser.email || "?").trim().split(/\s+/).filter(Boolean).map(w => w[0]).slice(0, 2).join("").toUpperCase();
  // Navigation inside a slim window STAYS slim: following a link from one
  // record to a related one must not suddenly grow a sidebar in a window with
  // no room for it. An explicit chrome in params still wins.
  const go = (page, params={}, opts={}) => {
    if (opts.replace) replaceNextRef.current = true;
    const carry = (view.chrome === "slim" && !("chrome" in params)) ? { chrome: "slim" } : {};
    setView({ page, ...params, ...carry });
    setTab("overview"); setNotifOpen(false); setUserMenuOpen(false); setError(null);
  };
  roleRef.current = role;   // read by the Action Center count and landing (defined above the early returns)
  // Anchor click handler: left-click navigates in-app; modifier/middle clicks
  // fall through to the browser so "open in new tab/window" works natively.
  // Is THIS window a slim record window?
  const slim = view.chrome === "slim";

  // Open a record in its own chromeless browser window.
  //
  // What the browser gives us: no tab strip, no bookmarks bar, no back/forward,
  // no extensions. What it does NOT give us, whatever we ask for, is a hidden
  // URL -- every browser has forced a read-only origin strip onto script-opened
  // windows for a decade as an anti-phishing measure. `location=no` is ignored.
  // This is as close to chromeless as the platform allows.
  //
  // The window name is per PAGE TYPE, not per record, so working down a list
  // reuses one window instead of scattering ten across the desktop. Reuse only
  // changes the hash, which is why the hashchange listener above exists.
  //
  // Returns false when the window could not be opened -- a blocker, or a policy
  // that forces new windows into tabs -- so the caller falls back to ordinary
  // in-app navigation rather than leaving the click dead.
  const openSlim = (page, params={}) => {
    try {
      const w = Math.min(1180, (window.screen.availWidth || 1400) - 60);
      const h = Math.min(880, (window.screen.availHeight || 900) - 80);
      const left = Math.round((window.screenX || 0) + Math.max(0, ((window.outerWidth || w) - w) / 2));
      const top  = Math.round((window.screenY || 0) + Math.max(0, ((window.outerHeight || h) - h) / 3));
      const win = window.open(
        hrefFor(page, { ...params, chrome: "slim" }),
        "ace_slim_" + page,
        `popup=yes,width=${w},height=${h},left=${left},top=${top}`);
      if (!win) return false;
      win.focus();
      return true;
    } catch (e) { return false; }
  };

  // Should this navigation become a slim window rather than a page change?
  // No when we are already IN one (windows must not spawn windows), and no
  // while testing as another user -- impersonation lives in React state, not
  // localStorage, so a new window comes up as the real admin and quietly
  // undoes the test you were running.
  const wantsSlim = (page) => SLIM_PAGES.has(page) && !slim && !impersonateUser;

  const navClick = (e, navKey, params={}, opts={}) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (wantsSlim(navKey) && openSlim(navKey, params)) return;
    go(navKey, params, opts);
  };
  // URL for an in-app page (used as an <a href> so links are shareable/right-clickable).
  const hrefFor = (page, params={}) => serializeView(app, { page, ...params });
  // Props to spread onto a clickable <tr> or card: modifier-aware left-click nav
  // (plain click routes in-app; ctrl/cmd/shift bows out so an anchor cell can open
  // a new tab) plus middle-click → new tab. Pair with a <PageLink> on the row's
  // identifying cell to give right-click its native "Open in new tab" target.
  const rowNav = (page, params={}) => ({
    onClick: (e) => { if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (wantsSlim(page) && openSlim(page, params)) return;
      go(page, params); },
    onAuxClick: (e) => { if (e.button === 1) { e.preventDefault(); window.open(hrefFor(page, params), "_blank", "noopener"); } },
  });
  const closeModal = () => { setModal(null); setSaving(false); setError(null); };
  // ── Admin "test as user" ──
  // Land on the first app the target can actually open. Hard-coding "upm" was
  // fine while everyone could enter it; a sales-only BDO would now be dropped
  // into an app they are blocked from, with every request 403ing behind it.
  const landingApp = (u) => (APPS.find(a => appAllowed(a, u)) || { id: "upm" }).id;
  const startImpersonate = (u) => {
    setImpersonateUser(u); setImpersonatePicker(false); setUserMenuOpen(false);
    const id = landingApp({ ...u, role: u.Role });
    setApp(id); setView({ page: DEFAULT_PAGE[id] }); setTab("overview");
  };
  const stopImpersonate = () => {
    setImpersonateUser(null);
    const id = landingApp(currentUser);
    setApp(id); setView({ page: DEFAULT_PAGE[id] }); setTab("overview");
  };
  const openImpersonatePicker = () => { setUserMenuOpen(false); setImpersonatePicker(true); if (impUsers.length === 0) api.get("getUsers").then(r => setImpUsers(Array.isArray(r) ? r : [])).catch(() => {}); };

  const AppSwitcher = ({ currentApp, onSelect, user }) => {
    const [open, setOpen] = useState(false);
    useEscape(open ? () => setOpen(false) : null);
    const available = APPS.filter(a => appAllowed(a, user));
    if (available.length < 2) return null;           // non-PM: nothing to switch to → hide
    return (
      <div style={{ position:"relative" }}>
        <button title="Switch application" onClick={()=>setOpen(o=>!o)}
          style={{ display:"grid", gridTemplateColumns:"repeat(3,4px)", gap:3, padding:8, background:"transparent", border:"none", cursor:"pointer", color:B.cyanMid }}>
          {Array.from({length:9}).map((_,i)=><span key={i} style={{ width:4, height:4, borderRadius:1, background:"currentColor" }} />)}
        </button>
        {open && <>
          <div onClick={()=>setOpen(false)} style={{ position:"fixed", inset:0, zIndex:900 }} />
          <div style={{ position:"absolute", right:0, top:"calc(100% + 6px)", zIndex:901, background:"var(--color-background, #fff)", border:"1px solid var(--color-border, #e5e7eb)", borderRadius:10, boxShadow:"0 8px 28px rgba(0,0,0,0.18)", padding:10, width:290 }}>
            <div style={{ fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:"0.06em", color:"var(--color-text-secondary)", padding:"2px 6px 8px" }}>Applications</div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, gridAutoRows:"1fr" }}>
              {available.map(a=>(
                <button key={a.id} onClick={()=>{ onSelect(a.id); setOpen(false); }}
                  style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"flex-start", gap:8, height:"100%", minHeight:96, padding:"14px 8px", borderRadius:8,
                    border: a.id===currentApp ? "2px solid "+a.color : "1px solid var(--color-border, #e5e7eb)",
                    background: a.id===currentApp ? a.color+"18" : "transparent", cursor:"pointer" }}>
                  <div style={{ width:40, height:40, borderRadius:10, background:a.color, color:"#fff", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:700, fontSize:15 }}>{a.icon ? <a.icon size={22} /> : a.short}</div>
                  <span style={{ fontSize:12, fontWeight:500, lineHeight:1.2, textAlign:"center" }}>{a.name}</span>
                </button>
              ))}
            </div>
          </div>
        </>}
      </div>
    );
  };


  const audit = async (action, tableName, recordId, detail) => {
    try { await api.post("saveAuditLog",{ ts:now(), userName:currentUser.name, role:currentUser.role, action, tableName, recordId, detail }); } catch(e) {}
  };
  const saveRec = async (endpoint, body, auditAction, auditTable, auditDetail, onDone) => {
    setSaving(true); setError(null);
    try {
      const result = await api.post(endpoint, body);
      // auditDetail may be a function of the response. A record whose number is
      // assigned by the SERVER cannot be named by the form that created it —
      // before this, every new loan was audited as "Added loan: " with nothing
      // after the colon.
      const detail = typeof auditDetail === "function" ? auditDetail(result || {}) : auditDetail;
      await audit(auditAction, auditTable, body.id||result.id, detail);
      closeModal(); if(onDone) onDone();
    } catch(e) { if(e.message==="UNAUTHORIZED"){handleLogout();return;} setError(e.message); setSaving(false); }
  };
  // Some deletes take more than the row you named — a borrower carries its bank
  // accounts and their collections, a covenant carries its calendar. The flow
  // asks the server what would go, says so, and only then deletes. It lives in
  // shared/deleteFlow.js so it can be tested without a browser; see the comment
  // at the top of that file for why the two steps are the same code path.
  const delRec = (table, id, detail, onDone) =>
    runDelete({ api, audit, setConfirm, setError, onUnauthorized: handleLogout },
              table, id, detail, onDone);

  // App-level state/handlers exposed to nested pages & forms (consumed via useApp()).
  const appCtx = {
    api, currentUser: effectiveUser, role,
    // Whether an admin is currently "testing as" someone else. Pages need this
    // to decide whether opening a record in a NEW TAB is safe: impersonation
    // lives in React state, not localStorage, so a new tab comes up as the real
    // admin — which silently undoes the test you were in the middle of.
    impersonating: !!impersonateUser,
    // slim: this window is a chromeless single-record window, so pages can drop
    // furniture of their own. openSlim: open a record in one deliberately.
    slim, openSlim, wantsSlim,
    view, go, hrefFor, navClick, rowNav, tab, setTab,
    modal, setModal, closeModal,
    confirm, setConfirm,
    saving, error, setError,
    saveRec, delRec, audit,
    app, setApp, handleLogout,
    loadBiDashboards, authState, biDashboards,
    actionCount, setActionCount,
  };



    // IntegrationWFPage
    // api, B, Card, SectionHeader, useState, useEffect).
    // Uses api.get(name, params) and api.post(name, body)

    function IntegrationPlaidPage() {
      const [loading, setLoading] = useState(true);
      const [saving, setSaving]   = useState(false);
      const [msg, setMsg]         = useState(null);

      const [clientId, setClientId]       = useState("");
      const [environment, setEnvironment] = useState("sandbox");
      const [redirectUri, setRedirectUri] = useState("");
      const [secret, setSecret]           = useState("");   // plaid-secret (write-only)
      const [status, setStatus]           = useState({});   // secretstatus map

      // Connections (linked client banks) + sync controls.
      const [conns, setConns]       = useState(null);
      const [connLoading, setConnLoading] = useState(true);
      const [connErr, setConnErr]   = useState(null);
      const [syncKey, setSyncKey]   = useState(null);       // which sync is running
      const [syncMsg, setSyncMsg]   = useState(null);

      const load = async () => {
        setLoading(true);
        try {
          const data = await api.get("getIntegrations", { provider: "plaid" });
          const c = (data && data.config) || {};
          setClientId(c.client_id || "");
          setEnvironment(c.environment || "sandbox");
          setRedirectUri(c.redirect_uri || "");
          setStatus((data && data.secretstatus) || {});
        } catch (e) { setMsg({ type:"err", text:e.message }); }
        setLoading(false);
      };
      useEffect(() => { load(); }, []);

      const loadConns = async (refresh) => {
        setConnLoading(true); setConnErr(null);
        try {
          setConns(await api.get("plaidConnections", refresh === false ? { refresh: "false" } : undefined));
        } catch (e) { setConnErr(e.message); }
        setConnLoading(false);
      };
      useEffect(() => { loadConns(false); }, []);   // fast first paint (stored status)

      const runSync = async (key, body) => {
        setSyncKey(key); setSyncMsg(null);
        try {
          const r = await api.post("plaidRunSync", body);
          setSyncMsg({ type:"ok", text:`Synced ${r.items} connection(s) · ${r.transactions} transactions${r.errors ? ` · ${r.errors} error(s)` : ""}${r.alertScan && r.alertScan.ok ? " · bank alerts rescanned" : r.alertScan && r.alertScan.ran ? " · bank alert rescan failed (runs again tonight)" : ""}.` });
          loadConns(true);
        } catch (e) { setSyncMsg({ type:"err", text:e.message }); }
        setSyncKey(null);
      };

      // ── Reconnect: repair a broken connection from here ──
      // Opens Plaid Link in UPDATE MODE on the existing item (api/plaidLinkToken
      // with itemId), so an admin can sign in with the borrower's read-only
      // credentials and the SAME connection comes back — same accounts, same
      // transaction history, no stand-in portal user. Then a 3-day sync.
      const loadPlaidLink = () => new Promise((resolve, reject) => {
        if (window.Plaid) return resolve(window.Plaid);
        const s = document.createElement("script");
        s.src = "https://cdn.plaid.com/link/v2/stable/link-initialize.js";
        s.onload = () => window.Plaid ? resolve(window.Plaid) : reject(new Error("Plaid Link did not load."));
        s.onerror = () => reject(new Error("Could not load Plaid Link (cdn.plaid.com)."));
        document.body.appendChild(s);
      });
      const reconnect = async (it) => {
        const who = it.companyname || ("account " + it.accountId);
        setSyncKey(it.plaidItemId + "-fix"); setSyncMsg(null);
        try {
          const r = await api.post("plaidLinkToken", { itemId: it.plaidItemId, accountId: it.accountId });
          const Plaid = await loadPlaidLink();
          const handler = Plaid.create({
            token: r.link_token,
            onSuccess: async () => {
              try { handler.destroy(); } catch (e) { /* already gone */ }
              setSyncMsg({ type:"ok", text:`${who} · ${it.institutionName || "bank"} reconnected — pulling the last 3 days…` });
              await runSync(it.plaidItemId + "-3", { plaidItemId: it.plaidItemId, days:3 });
            },
            onExit: (err) => {
              try { handler.destroy(); } catch (e) { /* already gone */ }
              if (err) setSyncMsg({ type:"err", text:"Plaid: " + (err.display_message || err.error_message || err.error_code || "closed with an error") });
              setSyncKey(null);
            },
          });
          handler.open();
        } catch (e) { setSyncMsg({ type:"err", text:e.message }); setSyncKey(null); }
      };

      const fmtMoney = (v, cur) => (v === null || v === undefined || v === "")
        ? "—" : new Intl.NumberFormat("en-US", { style:"currency", currency: cur || "USD" }).format(Number(v));
      const fmtDay = (d) => { if (!d) return "—"; const x = new Date(d); return isNaN(x) ? "—" : x.toLocaleDateString("en-US"); };

      const save = async () => {
        setSaving(true); setMsg(null);
        try {
          const secrets = {};
          if (secret && secret.trim() !== "") secrets["plaid-secret"] = secret.trim();
          const config = {
            client_id: clientId.trim(),
            environment,
            redirect_uri: redirectUri.trim() || undefined,
          };
          const res = await api.post("saveIntegration", {
            provider: "plaid", displayname: "Plaid", config, secrets, isactive: true,
          });
          setStatus(res.secretstatus || status);
          setSecret("");
          setMsg({ type:"ok", text:"Configuration saved." });
          load();
        } catch (e) { setMsg({ type:"err", text:e.message }); }
        setSaving(false);
      };

      const lbl = { display:"block", fontSize:12, fontWeight:600, color:"var(--color-text-secondary)", marginBottom:5 };
      const inp = { width:"100%", padding:"8px 10px", fontSize:13, border:"1px solid var(--color-border, #d5dbe2)", borderRadius:6, boxSizing:"border-box", fontFamily:"var(--font-sans)" };
      const row = { marginBottom:14 };
      const banner = (t) => ({ padding:"8px 12px", borderRadius:6, fontSize:13, marginTop:12, background: t==="ok" ? "#E1F5EE" : "#FAECE7", color: t==="ok" ? "#0F6E56" : "#993C1D" });

      if (loading) return <div style={{ padding:20, color:"var(--color-text-secondary)" }}>Loading…</div>;

      const secretSet = !!status["plaid-secret"];

      return (
        <>
          <SectionHeader title="Plaid Integration" />
          <Card style={{ marginBottom:16, maxWidth:640 }}>
            <div style={{ fontSize:14, fontWeight:600, marginBottom:4 }}>Credentials</div>
            <div style={{ fontSize:12, color:"var(--color-text-secondary)", marginBottom:16 }}>
              The secret is stored in Azure Key Vault, never in the database, and is never shown back — re-enter it only to replace it. The client portal reads this configuration to link and display client bank accounts.
            </div>
            <div style={row}>
              <label style={lbl}>Client ID</label>
              <input value={clientId} onChange={e => setClientId(e.target.value)} placeholder="Plaid client_id" style={inp} />
            </div>
            <div style={row}>
              <label style={lbl}>Secret {secretSet && <span style={{ color:"#0F6E56", fontWeight:500 }}>✓ set</span>}</label>
              <input type="password" value={secret} onChange={e => setSecret(e.target.value)} placeholder={secretSet ? "•••••••••  set — leave blank to keep" : "Not set"} style={inp} />
            </div>
            <div style={row}>
              <label style={lbl}>Environment</label>
              <select value={environment} onChange={e => setEnvironment(e.target.value)} style={inp}>
                <option value="sandbox">Sandbox</option>
                <option value="development">Development</option>
                <option value="production">Production</option>
              </select>
            </div>
            <div style={{ ...row, marginBottom:0 }}>
              <label style={lbl}>Redirect URI <span style={{ fontWeight:400, color:"var(--color-text-secondary)" }}>(optional — for OAuth banks)</span></label>
              <input value={redirectUri} onChange={e => setRedirectUri(e.target.value)} placeholder={org("portalUrlExample")} style={inp} />
            </div>
          </Card>
          <button onClick={save} disabled={saving} style={{ padding:"8px 16px", background:B.cyan, color:"#fff", border:"none", borderRadius:6, fontSize:13, fontWeight:500, cursor:saving?"not-allowed":"pointer", opacity:saving?0.6:1 }}>
            {saving ? "Saving…" : "Save configuration"}
          </button>
          {msg && <div style={banner(msg.type)}>{msg.text}</div>}

          {/* Connections */}
          <Card style={{ marginTop:24 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:4 }}>
              <div style={{ fontSize:14, fontWeight:600 }}>Client Connections</div>
              <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                <button onClick={() => loadConns(true)} disabled={connLoading}
                  style={{ padding:"6px 12px", background:"#fff", color:B.cyan, border:`1px solid ${B.cyan}`, borderRadius:6, fontSize:12, fontWeight:600, cursor:"pointer" }}>
                  Refresh status
                </button>
                <button onClick={() => runSync("all-3", { days:3 })} disabled={!!syncKey}
                  style={{ padding:"6px 12px", background:B.cyan, color:"#fff", border:"none", borderRadius:6, fontSize:12, fontWeight:600, cursor:syncKey?"not-allowed":"pointer", opacity:syncKey?0.6:1 }}>
                  {syncKey==="all-3" ? "Syncing…" : "Sync all · last 3 days"}
                </button>
                <button onClick={() => runSync("all-120", { days:120 })} disabled={!!syncKey}
                  style={{ padding:"6px 12px", background:"#0d3d52", color:"#fff", border:"none", borderRadius:6, fontSize:12, fontWeight:600, cursor:syncKey?"not-allowed":"pointer", opacity:syncKey?0.6:1 }}>
                  {syncKey==="all-120" ? "Syncing…" : "Sync all · last 4 months"}
                </button>
              </div>
            </div>
            <div style={{ fontSize:12, color:"var(--color-text-secondary)", marginBottom:14 }}>
              Every client account with a Plaid link, its connection health, and each account’s mask and most recent stored balance.
              A daily 3-day sync also runs on schedule (Azure Logic App); these buttons are for on-demand pulls and initial backfills.
            </div>
            {syncMsg && <div style={banner(syncMsg.type)}>{syncMsg.text}</div>}

            {connLoading ? (
              <div style={{ fontSize:13, color:"var(--color-text-secondary)", padding:"8px 0" }}>Loading…</div>
            ) : connErr ? (
              <div style={{ ...banner("err") }}>{connErr}</div>
            ) : !conns || conns.length === 0 ? (
              <div style={{ fontSize:13, color:"var(--color-text-secondary)", padding:"8px 0" }}>No Plaid connections yet.</div>
            ) : (
              <div style={{ marginTop:8 }}>
                {conns.map((it) => {
                  const active = it.status === "active";
                  const busy = syncKey === it.plaidItemId + "-3" || syncKey === it.plaidItemId + "-120";
                  return (
                    <div key={it.plaidItemId} style={{ border:"1px solid var(--color-border, #e2e7ec)", borderRadius:8, padding:"12px 14px", marginBottom:10 }}>
                      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", gap:12 }}>
                        <div style={{ minWidth:0 }}>
                          {/* Whose connection this is: the borrower, linked to its account. */}
                          <div style={{ fontSize:14, fontWeight:700, marginBottom:2 }}>
                            <a href="#" onClick={e => { e.preventDefault(); go("account", { accountid: it.accountId, companyname: it.companyname }); }}
                               style={{ color:B.cyanDark, textDecoration:"none" }}>{it.companyname || "Account " + it.accountId}</a>
                          </div>
                          <div style={{ fontSize:13, fontWeight:600 }}>
                            {it.institutionName || "Bank"} <span style={{ color:"var(--color-text-secondary)", fontWeight:400 }}>· Account {it.accountId}</span>
                          </div>
                          <div style={{ fontSize:11, color:"var(--color-text-secondary)", marginTop:2 }}>
                            Last sync: {fmtDay(it.lastSyncUtc)}{!active && it.statusDetail ? `  ·  ${it.statusDetail}` : ""}
                          </div>
                        </div>
                        <div style={{ display:"flex", alignItems:"center", gap:8, flexShrink:0 }}>
                          <span style={{ background: active ? "#E1F5EE" : "#FAECE7", color: active ? "#0F6E56" : "#993C1D", borderRadius:999, padding:"3px 10px", fontSize:12, fontWeight:600 }}>
                            {active ? "Active" : "Not Active"}
                          </span>
                          {/* Repair this same connection with the borrower's read-only
                              sign-in. Red when it is broken; outlined when it is fine. */}
                          <button onClick={() => reconnect(it)} disabled={!!syncKey}
                            title="Sign in to the bank again through Plaid and repair this connection (same accounts and history)"
                            style={{ padding:"5px 10px", background: active ? "#fff" : "#993C1D", color: active ? "#993C1D" : "#fff",
                                     border:"1px solid #993C1D", borderRadius:6, fontSize:11, fontWeight:600,
                                     cursor:syncKey?"not-allowed":"pointer", opacity:syncKey?0.6:1 }}>
                            {syncKey===it.plaidItemId+"-fix" ? "…" : "Reconnect"}
                          </button>
                          <button onClick={() => runSync(it.plaidItemId + "-3", { plaidItemId: it.plaidItemId, days:3 })} disabled={!!syncKey}
                            style={{ padding:"5px 10px", background:B.cyan, color:"#fff", border:"none", borderRadius:6, fontSize:11, fontWeight:600, cursor:syncKey?"not-allowed":"pointer", opacity:syncKey?0.6:1 }}>
                            {syncKey===it.plaidItemId+"-3" ? "…" : "3 days"}
                          </button>
                          <button onClick={() => runSync(it.plaidItemId + "-120", { plaidItemId: it.plaidItemId, days:120 })} disabled={!!syncKey}
                            style={{ padding:"5px 10px", background:"#0d3d52", color:"#fff", border:"none", borderRadius:6, fontSize:11, fontWeight:600, cursor:syncKey?"not-allowed":"pointer", opacity:syncKey?0.6:1 }}>
                            {syncKey===it.plaidItemId+"-120" ? "…" : "4 months"}
                          </button>
                        </div>
                      </div>

                      {(it.accounts || []).length > 0 && (
                        <table style={{ width:"100%", borderCollapse:"collapse", marginTop:10, fontSize:12 }}>
                          <thead>
                            <tr style={{ textAlign:"left", color:"var(--color-text-secondary)" }}>
                              <th style={{ padding:"4px 6px", fontWeight:600 }}>Account</th>
                              <th style={{ padding:"4px 6px", fontWeight:600 }}>Mask</th>
                              <th style={{ padding:"4px 6px", fontWeight:600 }}>Type</th>
                              <th style={{ padding:"4px 6px", fontWeight:600, textAlign:"right" }}>Current Balance</th>
                              <th style={{ padding:"4px 6px", fontWeight:600, textAlign:"right" }}>As Of</th>
                            </tr>
                          </thead>
                          <tbody>
                            {it.accounts.map((a) => (
                              <tr key={a.plaidAccountId} style={{ borderTop:"1px solid var(--color-border, #eef1f4)" }}>
                                <td style={{ padding:"4px 6px" }}>{a.name || a.officialName || "—"}</td>
                                <td style={{ padding:"4px 6px" }}>{a.mask ? "••" + a.mask : "—"}</td>
                                <td style={{ padding:"4px 6px" }}>{a.subtype || a.type || "—"}</td>
                                <td style={{ padding:"4px 6px", textAlign:"right" }}>{fmtMoney(a.currentBalance, a.currency)}</td>
                                <td style={{ padding:"4px 6px", textAlign:"right" }}>{fmtDay(a.balanceAsOf)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </Card>
        </>
      );
    }

    function IntegrationWFPage() {
      const [loading, setLoading] = useState(true);
      const [saving, setSaving]   = useState(false);
      const [msg, setMsg]         = useState(null);

      const [entityId, setEntityId] = useState("");
      const [accounts, setAccounts] = useState([]);          // [{ bankId, accountNumber, label }]
      const [sec, setSec]           = useState({ ck:"", cs:"", cert:"", key:"", pass:"" });
      const [status, setStatus]     = useState({});          // secretstatus map from server

      const DEFAULTS = {
        tokenUrl:  "https://api.wellsfargo.com/oauth2/v1/token",
        searchUrl: "https://api.wellsfargo.com/treasury/transaction-reporting/v3/transactions/search?grant_type=client_credentials",
        scope:     "TM-Transaction-Search TM-Transaction-Report Account-Balance",
      };

      // Editable endpoints — seeded from config, fall back to defaults on a new row.
      const [tokenUrl, setTokenUrl]   = useState(DEFAULTS.tokenUrl);
      const [searchUrl, setSearchUrl] = useState(DEFAULTS.searchUrl);
      const [scope, setScope]         = useState(DEFAULTS.scope);

      const [startDate, setStartDate] = useState("");
      const [endDate, setEndDate]     = useState("");
      const [syncing, setSyncing]     = useState(false);
      const [syncMsg, setSyncMsg]     = useState(null);
      const [lastSync, setLastSync]   = useState(null);

      const SECRET_NAME = {
        ck:"wf-consumer-key", cs:"wf-consumer-secret", cert:"wf-client-cert",
        key:"wf-client-key", pass:"wf-client-key-passphrase",
      };

      const load = async () => {
        setLoading(true);
        try {
          const data = await api.get("getIntegrations", { provider: "wellsfargo" });
          const c = (data && data.config) || {};
          setEntityId(c.gatewayEntityId || "");
          setAccounts(c.accounts || []);
          setTokenUrl(c.tokenUrl || DEFAULTS.tokenUrl);
          setSearchUrl(c.searchUrl || DEFAULTS.searchUrl);
          setScope(c.scope || DEFAULTS.scope);
          setStatus((data && data.secretstatus) || {});
          setLastSync(data ? { date: data.lastsyncdate, status: data.lastsyncstatus } : null);
        } catch (e) { setMsg({ type:"err", text:e.message }); }
        setLoading(false);
      };
      useEffect(() => { load(); }, []);

      const setAcct = (i, field, val) =>
        setAccounts(a => a.map((row, idx) => idx === i ? { ...row, [field]: val } : row));
      const addAcct = () => setAccounts(a => [...a, { bankId:"", accountNumber:"", label:"", postable:false }]);
      const rmAcct  = (i) => setAccounts(a => a.filter((_, idx) => idx !== i));

      const save = async () => {
        setSaving(true); setMsg(null);
        try {
          const secrets = {};
          Object.entries(sec).forEach(([k, v]) => { if (v && v.trim() !== "") secrets[SECRET_NAME[k]] = v; });
          const config = {
            tokenUrl: tokenUrl.trim(),
            searchUrl: searchUrl.trim(),
            scope: scope.trim(),
            gatewayEntityId: entityId.trim(),
            // Every account here is swept into dbo.wftransactions regardless.
            // `postable` only decides which ones dbo.vWFTransactions exposes to
            // the Pmt Posting screen. Coerced to a real boolean so an older row
            // saved before this existed reads as false rather than undefined.
            accounts: accounts
              .filter(a => a.accountNumber && a.bankId)
              .map(a => ({ ...a, postable: !!a.postable })),
          };
          const res = await api.post("saveIntegration", {
            provider: "wellsfargo", displayname: "Wells Fargo", config, secrets, isactive: true,
          });
          setStatus(res.secretstatus || status);
          setSec({ ck:"", cs:"", cert:"", key:"", pass:"" });
          setMsg({ type:"ok", text:"Configuration saved." });
          load();
        } catch (e) { setMsg({ type:"err", text:e.message }); }
        setSaving(false);
      };

      const runSync = async () => {
        if (!startDate || !endDate) { setSyncMsg({ type:"err", text:"Pick a start and end date." }); return; }
        setSyncing(true); setSyncMsg(null);
        try {
          const res = await api.post("wfSyncTransactions", { startDate, endDate });
          setSyncMsg({ type:"ok", text:`${res.inserted} new / ${res.fetched} fetched.` });
          load();
        } catch (e) { setSyncMsg({ type:"err", text:e.message }); }
        setSyncing(false);
      };

      // ---- styles ----
      const lbl = { display:"block", fontSize:12, fontWeight:600, color:"var(--color-text-secondary)", marginBottom:5 };
      const inp = { width:"100%", padding:"8px 10px", fontSize:13, border:"1px solid var(--color-border, #d5dbe2)",
                    borderRadius:6, boxSizing:"border-box", fontFamily:"var(--font-sans)" };
      const row = { marginBottom:14 };
      const btn = (bg) => ({ padding:"8px 16px", background:bg, color:"#fff", border:"none",
                    borderRadius:6, fontSize:13, fontWeight:500, cursor:"pointer" });
      const banner = (t) => ({ padding:"8px 12px", borderRadius:6, fontSize:13, marginTop:12,
                    background: t==="ok" ? "#E1F5EE" : "#FAECE7", color: t==="ok" ? "#0F6E56" : "#993C1D" });

      const SecretField = ({ k, label, multiline }) => {
        const isSet = !!status[SECRET_NAME[k]];
        const ph = isSet ? "•••••••••  set — leave blank to keep" : "Not set";
        return (
          <div style={row}>
            <label style={lbl}>
              {label} {isSet && <span style={{ color:"#0F6E56", fontWeight:500 }}>✓ set</span>}
            </label>
            {multiline
              ? <textarea rows={4} value={sec[k]} placeholder={ph}
                  onChange={e => setSec(s => ({ ...s, [k]: e.target.value }))}
                  style={{ ...inp, fontFamily:"monospace", fontSize:11, resize:"vertical" }} />
              : <input type="password" value={sec[k]} placeholder={ph}
                  onChange={e => setSec(s => ({ ...s, [k]: e.target.value }))} style={inp} />}
          </div>
        );
      };

      if (loading) return <div style={{ padding:20, color:"var(--color-text-secondary)" }}>Loading…</div>;

      return (
        <>
          <SectionHeader title="Wells Fargo Integration" />

          {/* Credentials */}
          <Card style={{ marginBottom:16, maxWidth:640 }}>
            <div style={{ fontSize:14, fontWeight:600, marginBottom:4 }}>Credentials</div>
            <div style={{ fontSize:12, color:"var(--color-text-secondary)", marginBottom:16 }}>
              Stored in Azure Key Vault, never in the database. Values are never shown back —
              re-enter a field only to replace it.
            </div>
            <SecretField k="ck"   label="Consumer Key" />
            <SecretField k="cs"   label="Consumer Secret" />
            <SecretField k="cert" label="Client Certificate (CRT / PEM)" multiline />
            <SecretField k="key"  label="Client Private Key (KEY / PEM)" multiline />
            <SecretField k="pass" label="Key Passphrase" />
            <div style={row}>
              <label style={lbl}>Gateway Entity ID</label>
              <input value={entityId} onChange={e => setEntityId(e.target.value)}
                    placeholder="Provided by Wells Fargo onboarding" style={inp} />
            </div>
          </Card>

          {/* Endpoints */}
          <Card style={{ marginBottom:16, maxWidth:640 }}>
            <div style={{ fontSize:14, fontWeight:600, marginBottom:4 }}>Endpoints</div>
            <div style={{ fontSize:12, color:"var(--color-text-secondary)", marginBottom:16 }}>
              Non-secret. Token URL is the base endpoint (grant_type & scope are appended automatically).
              Search URL is used exactly as entered, including any query string.
            </div>
            <div style={row}>
              <label style={lbl}>Token URL</label>
              <input value={tokenUrl} onChange={e => setTokenUrl(e.target.value)} style={inp} />
            </div>
            <div style={row}>
              <label style={lbl}>Transaction Search URL</label>
              <input value={searchUrl} onChange={e => setSearchUrl(e.target.value)} style={inp} />
            </div>
            <div style={{ ...row, marginBottom:0 }}>
              <label style={lbl}>Scope</label>
              <input value={scope} onChange={e => setScope(e.target.value)} style={inp} />
            </div>
          </Card>

          {/* Accounts */}
          <Card style={{ marginBottom:16, maxWidth:640 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
              <div style={{ fontSize:14, fontWeight:600 }}>Accounts</div>
              <button onClick={addAcct} style={btn(B.cyan)}>+ Add account</button>
            </div>
            {accounts.length === 0 &&
              <div style={{ fontSize:12, color:"var(--color-text-secondary)" }}>No accounts yet.</div>}
            <div style={{ fontSize:11, color:"var(--color-text-secondary)", marginBottom:10, lineHeight:1.5 }}>
              Every account listed here is swept in by the sync. <strong>Post</strong> decides which of
              them appear on the Pmt Posting screen — normally the collection accounts only, since
              credits into an operating account are not loan payments. Nothing is excluded from the
              database either way.
            </div>
            {accounts.map((a, i) => (
              <div key={i} style={{ display:"flex", gap:8, marginBottom:8, alignItems:"center" }}>
                <input value={a.bankId} onChange={e => setAcct(i, "bankId", e.target.value)}
                      placeholder="Bank ID / ABA" style={{ ...inp, flex:"0 0 120px" }} />
                <input value={a.accountNumber} onChange={e => setAcct(i, "accountNumber", e.target.value)}
                      placeholder="Account number" style={{ ...inp, flex:"0 0 150px" }} />
                <input value={a.label} onChange={e => setAcct(i, "label", e.target.value)}
                      placeholder="Label (e.g. 1BR Collection)" style={{ ...inp, flex:1 }} />
                <label title="Show this account's transactions on the Pmt Posting screen"
                       style={{ display:"flex", alignItems:"center", gap:5, flex:"0 0 auto",
                                fontSize:12, color:"var(--color-text-secondary)", whiteSpace:"nowrap", cursor:"pointer" }}>
                  <input type="checkbox" checked={!!a.postable}
                         onChange={e => setAcct(i, "postable", e.target.checked)}
                         style={{ width:15, height:15, cursor:"pointer" }} />
                  Post
                </label>
                <button onClick={() => rmAcct(i)}
                        style={{ ...btn("#993C1D"), padding:"6px 10px" }}>✕</button>
              </div>
            ))}
          </Card>

          <div style={{ maxWidth:640, marginBottom:24 }}>
            <button onClick={save} disabled={saving} style={btn(B.cyan)}>
              {saving ? "Saving…" : "Save configuration"}
            </button>
            {msg && <div style={banner(msg.type)}>{msg.text}</div>}
          </div>

          {/* Sync */}
          <Card style={{ maxWidth:640 }}>
            <div style={{ fontSize:14, fontWeight:600, marginBottom:4 }}>Pull transactions</div>
            <div style={{ fontSize:12, color:"var(--color-text-secondary)", marginBottom:16 }}>
              Fetches by posting date across all accounts and de-dupes automatically —
              overlapping ranges won't create duplicates.
            </div>
            <div style={{ display:"flex", gap:12, alignItems:"flex-end", flexWrap:"wrap" }}>
              <div>
                <label style={lbl}>Start date</label>
                <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} style={inp} />
              </div>
              <div>
                <label style={lbl}>End date</label>
                <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} style={inp} />
              </div>
              <button onClick={runSync} disabled={syncing} style={btn(B.amber)}>
                {syncing ? "Running…" : "Run sync"}
              </button>
            </div>
            {syncMsg && <div style={banner(syncMsg.type)}>{syncMsg.text}</div>}
            {lastSync && lastSync.date &&
              <div style={{ fontSize:12, color:"var(--color-text-secondary)", marginTop:12 }}>
                Last sync: {new Date(lastSync.date).toLocaleString()} — {lastSync.status}
              </div>}
          </Card>
        </>
      );
    }







      const ParticipantPmtChildSection = ({ participantscheduledpmtid, loanid, onReload }) => {
        const [pmts, setPmts] = useState([]);
        const [loading, setLoading] = useState(true);
        const reload = () => {
          setLoading(true);
          api.get("getParticipantPmts?participantscheduledpmtid="+participantscheduledpmtid)
            .then(d=>{ setPmts(d); setLoading(false); })
            .catch(()=>setLoading(false));
        };
        useEffect(()=>{ reload(); },[participantscheduledpmtid]);

        return <div style={{ overflowX:"auto" }}>
          <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:8 }}>
            {role.canEdit&&<Btn onClick={()=>setModal({
              type:"participantpmt-add",
              loanid,
              participantscheduledpmtid,
              onDone:reload
            })} variant="primary">+ Add Payment</Btn>}
          </div>
          {loading ? <Spinner /> : pmts.length===0
            ? <div style={{ fontSize:12, color:"var(--color-text-secondary)", padding:"8px 0" }}>No payments recorded.</div>
            : <table style={{ width:"100%", borderCollapse:"collapse", whiteSpace:"nowrap" }}>
                <thead><tr>
                  <Th>Payment Date</Th>
                  <Th>Principal</Th>
                  <Th>Interest</Th>
                  <Th>Fee Type</Th>
                  <Th>Fee</Th>
                  <Th>Other Type</Th>
                  <Th>Other</Th>
                  <Th>Total</Th>
                  <Th></Th>
                </tr></thead>
                <tbody>
                  {pmts.map(p=>(
                    <tr key={p.id} onMouseEnter={e=>e.currentTarget.style.background="var(--color-background-secondary)"} onMouseLeave={e=>e.currentTarget.style.background=""}>
                      <Td>{fmtDate(p.paymentdate)}</Td>
                      <TdNum>{fmt(p.principalamount||0)}</TdNum>
                      <TdNum>{fmt(p.interestamount||0)}</TdNum>
                      <Td>{p.feetype||"—"}</Td>
                      <TdNum>{fmt(p.feeamount||0)}</TdNum>
                      <Td>{p.othertype||"—"}</Td>
                      <TdNum>{fmt(p.otheramount||0)}</TdNum>
                      <TdNum style={{ fontWeight:500 }}>{fmt(p.totalpayment||0)}</TdNum>
                      <Td><div style={{ display:"flex",gap:6, justifyContent:"flex-end" }}>
                        <Btn onClick={()=>setModal({type:"participantpmt-view",rec:{...p,id:p.id,loanid:p.loanid}})}><Icon type="view" /></Btn>
                        {role.canEdit&&<Btn onClick={()=>setModal({type:"participantpmt-edit",rec:{...p,id:p.id,loanid:p.loanid},onDone:reload})}><Icon type="edit" /></Btn>}
                        {role.canDelete&&<Btn onClick={()=>setConfirm({msg:"Delete this payment?",onConfirm:()=>delRec("ParticipantPmts",p.id,"Deleted participant payment",reload)})} variant="danger"><Icon type="delete" /></Btn>}
                      </div></Td>
                    </tr>
                  ))}
                  {/* Total row */}
                  <tr style={{ background:B.cyanLight, borderTop:"1.5px solid "+B.cyan }}>
                    <td style={{ padding:"7px 12px", fontSize:12, fontWeight:600, color:B.cyanDark, textAlign:"right" }}>Total ({pmts.length})</td>
                    <TdNum style={{ fontWeight:600, color:B.cyanDark }}>{fmt(pmts.reduce((s,p)=>s+(parseFloat(p.principalamount)||0),0))}</TdNum>
                    <TdNum style={{ fontWeight:600, color:B.cyanDark }}>{fmt(pmts.reduce((s,p)=>s+(parseFloat(p.interestamount)||0),0))}</TdNum>
                    <td /><td />
                    <TdNum style={{ fontWeight:600, color:B.cyanDark }}>{fmt(pmts.reduce((s,p)=>s+(parseFloat(p.feeamount)||0),0))}</TdNum>
                    <td />
                    <TdNum style={{ fontWeight:600, color:B.cyanDark }}>{fmt(pmts.reduce((s,p)=>s+(parseFloat(p.otheramount)||0),0))}</TdNum>
                    <TdNum style={{ fontWeight:600, color:B.cyanDark }}>{fmt(pmts.reduce((s,p)=>s+(parseFloat(p.totalpayment)||0),0))}</TdNum>
                    <td />
                  </tr>
                </tbody>
              </table>}
        </div>;
      };











    // AllWFTransactionsPage

    function AllWFTransactionsPage() {
      const [allRows, setAllRows] = useState([]);
      const [loading, setLoading] = useState(true);
      const [status, setStatus]   = useState("unposted");   // unposted | posted | all
      const [err, setErr]         = useState(null);
      const [postRec, setPostRec] = useState(null);         // row being posted

      // Fetch everything once and split it here, rather than re-querying per tab.
      // The tab counts need all three numbers anyway, so asking the server for one
      // slice at a time would mean three round-trips to label three buttons. This
      // way switching tabs is instant and the counts are free.
      //
      // If this table ever grows past a few thousand rows, add a date range to the
      // request rather than going back to per-status fetches — the counts would
      // become wrong again the moment they are fetched separately from the rows.
      const load = async () => {
        setLoading(true); setErr(null);
        try {
          setAllRows(await api.get("getWFTransactions", { status: "all" }));
        } catch (e) { setErr(e.message); setAllRows([]); }
        setLoading(false);
      };
      useEffect(() => { load(); }, []);

      const counts = useMemo(() => {
        let posted = 0;
        for (const r of allRows) if (r.posted) posted++;
        return { unposted: allRows.length - posted, posted, all: allRows.length };
      }, [allRows]);

      const rows = useMemo(() => (
        status === "all" ? allRows
          : allRows.filter(r => (status === "posted" ? !!r.posted : !r.posted))
      ), [allRows, status]);

      const money = (n) => (n == null ? "" :
        Number(n).toLocaleString("en-US", { style:"currency", currency:"USD" }));
      const date = (d) => {
        if (!d) return "";
        const s = String(d).slice(0, 10);        // "2026-07-10"
        const [y, m, dd] = s.split("-");
        return `${Number(m)}/${Number(dd)}/${y}`; // 7/10/2026
      };

      const saveOverride = async (id, loanid) => {
        try {
          await api.post("setWFLoanOverride", { id, loanid: loanid || null });
          load();
        } catch (e) { setErr(e.message); }
      };
      const openReceivedPmt = async (rpid, scheduledpmtid) => {
        try {
          const rows = await api.get("getReceivedPmts", { scheduledpmtid });
          const rec = rows.find(r => r.id === rpid);
          if (!rec) { setErr(`Received payment ${rpid} not found`); return; }
          // onDone so an edit made from inside the modal refreshes this screen
          // rather than closing onto the figures it fetched before the change.
          setModal({ type: "rpmt-view", rec, onDone: load });
        } catch (e) { setErr(e.message); }
      };
      const btn = (bg, disabled) => ({
        padding:"4px 10px", background: disabled ? "#9aa5b1" : bg, color:"#fff",
        border:"none", borderRadius:4, fontSize:12,
        cursor: disabled ? "not-allowed" : "pointer", whiteSpace:"nowrap",
      });
      const tab = (active) => ({
        padding:"6px 14px", fontSize:13, cursor:"pointer", border:"none",
        borderBottom: active ? "2px solid "+B.cyan : "2px solid transparent",
        background:"none", color: active ? B.cyan : "var(--color-text-secondary)",
        fontWeight: active ? 600 : 400,
      });
      const countPill = (active) => ({
        marginLeft:6, padding:"1px 7px", borderRadius:10, fontSize:11, fontWeight:600,
        background: active ? B.cyan : "var(--color-background-secondary,#eef1f5)",
        color: active ? "#fff" : "var(--color-text-secondary)",
      });
      const mono = { fontFamily:"monospace", fontSize:11 };

      return (
        <>
          <SectionHeader title="WF Transactions" />

          <div style={{ display:"flex", gap:4, marginBottom:12, borderBottom:"1px solid var(--color-border,#e3e8ee)" }}>
            {["unposted","posted","all"].map(s => (
              <button key={s} onClick={() => setStatus(s)} style={tab(status === s)}>
                {s === "unposted" ? "Unposted" : s === "posted" ? "Posted" : "All"}
                {/* Hidden while loading rather than showing 0 — a real zero and a
                    not-yet-loaded zero look identical, and one of them is alarming. */}
                {!loading && <span style={countPill(status === s)}>{counts[s]}</span>}
              </button>
            ))}
          </div>

          {err && <div style={{ padding:"8px 12px", background:"#FAECE7", color:"#993C1D",
                                borderRadius:6, fontSize:13, marginBottom:12 }}>{err}</div>}

          <Card>
            {loading ? <div style={{ padding:20, color:"var(--color-text-secondary)" }}>Loading…</div>
            : rows.length === 0 ? <div style={{ padding:20, color:"var(--color-text-secondary)" }}>No transactions.</div>
            : (
              <div style={{ overflowX:"auto" }}>
                <table style={{ width:"100%", borderCollapse:"collapse" }}>
                  <thead><tr>
                    <Th>ID</Th>
                    <Th>Transaction ID</Th>
                    <Th>Posting Date</Th>
                    <Th>Account</Th>
                    <Th>Amount</Th>
                    <Th>Type</Th>
                    <Th>Description</Th>
                    <Th>Loan Ref</Th>
                    <Th>Target Sched Pmt</Th>
                    <Th>Status</Th>
                    <Th></Th>
                  </tr></thead>
                  <tbody>
                    {rows.map(r => {
                      const noLoan  = !r.loanreference;
                      const noSched = !!r.loanreference && !r.targetscheduledpmtid;
                      const blocked = noLoan || noSched;
                      return (
                        <tr key={r.id}
                            onMouseEnter={e => e.currentTarget.style.background="var(--color-background-secondary)"}
                            onMouseLeave={e => e.currentTarget.style.background=""}>
                          <Td style={mono}>{r.id}</Td>
                          <Td style={mono} title={r.uniquetransactionid || "none (sweep)"}>
                            {r.uniquetransactionid || <span style={{ color:"var(--color-text-secondary)" }}>—</span>}
                          </Td>
                          <Td>{wfDate(r.postingdate)}</Td>
                          <Td style={{ fontSize:12 }}>…{String(r.accountnumber).slice(-4)}</Td>
                          <Td style={{ fontWeight:500 }}>{money(r.transactionamount)}</Td>
                          <Td style={{ fontSize:12 }}>{r.transactiontype}</Td>
                          <Td style={{ fontSize:11, maxWidth:300, overflow:"hidden",
                                      textOverflow:"ellipsis", whiteSpace:"nowrap" }}
                              title={r.transactiondescription}>
                            {r.transactiondescription}
                          </Td>
                          <Td>
                            {/* Servicers set the loan; everyone else reads it. */}
                            {(r.posted || !role.isservicer) ? (r.loanreference || "—") : (
                              <input
                                defaultValue={r.loanreference || ""}
                                placeholder="none"
                                onBlur={e => {
                                  const v = e.target.value.trim();
                                  if (v !== (r.loanreference || "")) saveOverride(r.id, v);
                                }}
                                style={{ width:80, padding:"3px 6px", fontSize:12,
                                        border:"1px solid var(--color-border,#d5dbe2)", borderRadius:4,
                                        background: noLoan ? "#FAECE7" : "transparent",
                                        fontWeight: r.ismanualoverride ? 600 : 400 }}
                                title={r.ismanualoverride ? "Manual override" : "Matched by rule"} />
                            )}
                          </Td>
                          <Td style={{ fontSize:11, color: noSched ? "#993C1D" : "inherit" }}>
                            {r.targetscheduledpmtid
                              ? `${r.targetscheduledpmtid} (${wfDate(r.targetscheduleddate)})`
                              : (r.loanreference ? "none — create one" : "—")}
                          </Td>
                          <Td>
                            {r.posted
                              ? <span style={{ fontSize:11, background:"#E1F5EE", color:"#0F6E56",
                                              padding:"2px 8px", borderRadius:4 }}>Posted</span>
                              : <span style={{ fontSize:11, background:"#FFF4E0", color:"#8A5A00",
                                              padding:"2px 8px", borderRadius:4 }}>Pending</span>}
                          </Td>
                          <Td>
                            {!r.posted && role.isservicer && (
                              <button onClick={() => setPostRec(r)} disabled={blocked}
                                      style={btn(B.cyan, blocked)}
                                      title={noLoan ? "Set a loan reference first"
                                          : noSched ? "Loan has no unscheduled payment to post to"
                                          : "Post this transaction"}>
                                Post
                              </button>
                            )}
                          {r.posted && r.receivedpaymentid && (
                            <button onClick={() => openReceivedPmt(r.receivedpaymentid, r.postedscheduledpmtid)}
                                    style={{ ...mono, background:"none", border:"none", padding:0,
                                            color:B.cyan, cursor:"pointer", textDecoration:"underline" }}
                                    title="Open received payment">
                              {r.receivedpaymentid}
                            </button>
                          )}
                          </Td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </Card>

          {postRec && <PostWFTransactionModal rec={postRec}
                        onClose={() => setPostRec(null)}
                        onDone={() => { setPostRec(null); load(); }} />}
        </>
      );
    }


    // ---- Post modal: split the amount before committing ----
    function PostWFTransactionModal({ rec, onClose, onDone }) {
      useEscape(onClose || null);
      const amount = Number(rec.transactionamount);

      // Default: everything to principal.
      const [f, setF] = useState({
        receivedprincipal: amount,
        receivedinterest: 0,
        receivedfee: 0,
        receivedother: 0,
        receivedpassthrough: 0,
      });
      const [saving, setSaving] = useState(false);
      const [err, setErr]       = useState(null);

      const num = (v) => (v === "" || v == null ? 0 : Number(v));
      const total = Math.round(Object.values(f).reduce((a, b) => a + num(b), 0) * 100) / 100;
      const target = Math.round(amount * 100) / 100;
      const balanced = total === target;

      const set = (k, v) => setF(s => ({ ...s, [k]: v }));

      const submit = async () => {
        setSaving(true); setErr(null);
        try {
          await api.post("postWFTransaction", {
            id: rec.id,
            loanid: rec.loanreference,
            receivedprincipal:   num(f.receivedprincipal),
            receivedinterest:    num(f.receivedinterest),
            receivedfee:         num(f.receivedfee),
            receivedother:       num(f.receivedother),
            receivedpassthrough: num(f.receivedpassthrough),
            postedby: currentUser.name,
          });
          onDone();
        } catch (e) { setErr(e.message); setSaving(false); }
      };

      const lbl = { display:"block", fontSize:12, fontWeight:600,
                    color:"var(--color-text-secondary)", marginBottom:4 };
      const inp = { width:"100%", padding:"7px 9px", fontSize:13, textAlign:"right",
                    border:"1px solid var(--color-border,#d5dbe2)", borderRadius:6, boxSizing:"border-box" };
      const money = (n) => Number(n).toLocaleString("en-US", { style:"currency", currency:"USD" });

      const FIELDS = [
        ["receivedprincipal",   "Principal"],
        ["receivedinterest",    "Interest"],
        ["receivedfee",         "Fee"],
        ["receivedother",       "Other"],
        ["receivedpassthrough", "Passthrough"],
      ];

      return (
        <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.45)",
              display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000 }}>
          <div onClick={e => e.stopPropagation()} style={{ background:"var(--color-background,#fff)",
                borderRadius:10, padding:24, width:480, maxHeight:"90vh", overflowY:"auto",
                boxShadow:"0 8px 32px rgba(0,0,0,0.25)" }}>

            <div style={{ fontSize:16, fontWeight:600, marginBottom:4 }}>Post transaction</div>
            <div style={{ fontSize:12, color:"var(--color-text-secondary)", marginBottom:16 }}>
              Creates a Received Payment on scheduled payment <strong>{rec.targetscheduledpmtid}</strong> for
              loan <strong>{rec.loanreference}</strong>. The scheduled payment itself isn't modified.
            </div>

            <div style={{ background:"var(--color-background-secondary,#f5f7fa)", borderRadius:6,
                          padding:12, marginBottom:16, fontSize:12 }}>
              <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                <span style={{ color:"var(--color-text-secondary)" }}>Bank amount</span>
                <strong>{money(amount)}</strong>
              </div>
              <div style={{ display:"flex", justifyContent:"space-between", marginBottom:4 }}>
                <span style={{ color:"var(--color-text-secondary)" }}>Received date</span>
                <span>{wfDate(rec.postingdate)}</span>
              </div>
              <div style={{ display:"flex", justifyContent:"space-between" }}>
                <span style={{ color:"var(--color-text-secondary)" }}>Transaction ID</span>
                <span style={{ fontFamily:"monospace", fontSize:11 }}>
                  {rec.uniquetransactionid || "—"}
                </span>
              </div>
            </div>

            {FIELDS.map(([k, label]) => (
              <div key={k} style={{ marginBottom:10 }}>
                <label style={lbl}>{label}</label>
                <input type="number" step="0.01" value={f[k]}
                      onChange={e => set(k, e.target.value)} style={inp} />
              </div>
            ))}

            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center",
                          padding:"10px 12px", borderRadius:6, marginTop:6, marginBottom:16,
                          background: balanced ? "#E1F5EE" : "#FAECE7",
                          color: balanced ? "#0F6E56" : "#993C1D", fontSize:13 }}>
              <span style={{ fontWeight:600 }}>Split total</span>
              <span style={{ fontWeight:600 }}>
                {money(total)} {balanced ? "✓" : `≠ ${money(target)}`}
              </span>
            </div>

            {err && <div style={{ padding:"8px 12px", background:"#FAECE7", color:"#993C1D",
                                  borderRadius:6, fontSize:13, marginBottom:12 }}>{err}</div>}

            <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
              <button onClick={onClose} style={{ padding:"8px 16px", background:"none",
                        border:"1px solid var(--color-border,#d5dbe2)", borderRadius:6,
                        fontSize:13, cursor:"pointer" }}>Cancel</button>
              <button onClick={submit} disabled={!balanced || saving}
                      style={{ padding:"8px 16px",
                              background: (!balanced || saving) ? "#9aa5b1" : B.cyan,
                              color:"#fff", border:"none", borderRadius:6, fontSize:13, fontWeight:500,
                              cursor: (!balanced || saving) ? "not-allowed" : "pointer" }}>
                {saving ? "Posting…" : "Post payment"}
              </button>
            </div>
          </div>
        </div>
      );
    }








    // ─────────────────────────────────────────────────────────────
      // REPORT BUILDER
      // ─────────────────────────────────────────────────────────────






    
      
      













 
 

 
 


const biGroups = (()=>{
    const cats = {};
    biDashboards.forEach(d => { (cats[d.category||"Other"] = cats[d.category||"Other"] || []).push(d); });
    return Object.entries(cats).map(([category, items])=>({
      category,
      order: Math.min(...items.map(i => i.categoryorder ?? 9999)),
      items: items.slice().sort((a,b)=> (a.displayorder??9999)-(b.displayorder??9999) || (a.name||"").localeCompare(b.name||""))
    })).sort((a,b)=> a.order-b.order || a.category.localeCompare(b.category));
  })();




  
  const toggleNav = key => setNavOpen(p => ({...p, [key]:!p[key]}));

  const activeNav = page => {
    const p = view.page;
    if (page==="accounts")        return ["accounts","account"].includes(p);
    if (page==="all-loans")       return ["all-loans","loan"].includes(p);
    if (page==="all-terms")       return p==="all-terms";
    if (page==="all-draws")       return ["all-draws"].includes(p);
    if (page==="all-spmts")       return ["all-spmts","spmt"].includes(p);
    if (page==="all-achcollections") return p==="all-achcollections";
    if (page==="all-rpmts")       return p==="all-rpmts";
    if (page==="all-contacts")    return p==="all-contacts";
    if (page==="all-legal")       return p==="all-legal";
    if (page==="ucc-register")    return p==="ucc-register";
    if (page==="ucc-searches")    return p==="ucc-searches";
    // The matching screen is reached FROM Tax Monitoring and is part of setting
    // it up, so it keeps that nav item lit rather than appearing as its own.
    if (page==="tax-monitoring")  return p==="tax-monitoring" || p==="taxguard-matching";
    if (page==="news-monitor")    return p==="news-monitor";
    if (page==="mca-monitor")     return p==="mca-monitor";
    if (page==="bank-activity")   return p==="bank-activity";
    if (page==="all-mcacompanies") return p==="all-mcacompanies";
    if (page==="all-chargeoffs")  return p==="all-chargeoffs";
    if (page==="all-riskratings") return p==="all-riskratings";
    if (page==="all-rates")       return p==="all-rates";
    if (page==="all-forwardrates") return p==="all-forwardrates";
    if (page==="all-pmtpostingrules") return p==="all-pmtpostingrules";
    if (page==="all-statements")  return p==="all-statements";
    if (page==="all-funds")     return p === "all-funds";
    if (page==="all-notes")     return p === "all-notes";
    if (page==="all-covenants")         return p==="all-covenants";
    if (page==="all-covenant-calendar") return p==="all-covenant-calendar";
    if (page==="all-covenant-catalog")  return p==="all-covenant-catalog";
    if (page==="all-wftransactions") return p==="all-wftransactions";
    if (page==="all-bankaccounts")        return p==="all-bankaccounts";
    if (page==="all-borrowersguarantors") return p==="all-borrowersguarantors";
    if (page==="all-covenant-calendar-visual") return p==="all-covenant-calendar-visual";
    if (page==="all-checklist-catalog") return p==="all-checklist-catalog";
    if (page==="all-checklist-mapping") return p==="all-checklist-mapping";
    if (page==="all-checklist") return p==="all-checklist";
    if (page==="covenant-exceptions") return p==="covenant-exceptions";
    if (page==="collateral-home") return ["collateral-home","collateral-bbc"].includes(p);
    if (page==="collateral-portfolio") return p==="collateral-portfolio";
    if (page==="collateral-dashboard") return p==="collateral-dashboard";
    if (page==="collateral-insights") return p==="collateral-insights";

    return p===page;
  };

  const NavItem = ({ navKey, label, icon, badge }) => (
    <a href={serializeView(app, { page: navKey })} onClick={(e)=>navClick(e, navKey)}
       title={!sidebarOpen ? label + (badge > 0 ? ` — ${badge} waiting` : "") : ""} style={{
      background: activeNav(navKey) ? B.sidebarAct : "none",
      border: "none",
      color: activeNav(navKey) ? "#fff" : "rgba(255,255,255,0.7)",
      padding: sidebarOpen ? "9px 20px" : "9px 0",
      cursor: "pointer", fontSize: 13, width: "100%",
      borderLeft: activeNav(navKey) ? "3px solid "+B.cyan : "3px solid transparent",
      display:"flex", alignItems:"center", justifyContent: sidebarOpen ? "flex-start" : "center", gap:8,
      textDecoration:"none", boxSizing:"border-box"
    }}>
      {icon&&<span style={{ flexShrink:0, display:"flex", alignItems:"center" }}>{icon}</span>}
      {sidebarOpen&&<span>{label}</span>}
      {/* Zero does not get a badge. An empty queue is the normal state and does
          not need announcing; a pill reading 0 is a thing to check and dismiss
          every time you look at the sidebar.

          The ceiling is 500, not 99: a real backlog here runs to the hundreds
          and "99+" would flatten 120 and 900 into the same glyph, which is the
          difference between an afternoon and a project. Four characters still
          fit beside the label.

          Collapsed, there is no room for a pill, so the count goes into the
          tooltip above rather than being dropped — otherwise the one state
          worth noticing is invisible in exactly the layout people leave the
          sidebar in. */}
      {sidebarOpen && badge > 0 && (
        <span style={{ marginLeft:"auto", background:B.amber, color:B.amberDark,
                       fontSize:11, fontWeight:700, lineHeight:1,
                       padding:"3px 7px", borderRadius:999, flexShrink:0 }}>
          {badge > 500 ? "500+" : badge}
        </span>
      )}
    </a>
  );

  // The pill NavItem uses — the same rules (none at zero, 500+ ceiling).
  const NavBadge = ({ n }) => n > 0 ? (
    <span style={{ marginLeft:"auto", background:B.amber, color:B.amberDark,
                   fontSize:11, fontWeight:700, lineHeight:1,
                   padding:"3px 7px", borderRadius:999, flexShrink:0 }}>
      {n > 500 ? "500+" : n}
    </span>) : null;

  const NavChild = ({ navKey, label, nested, badge }) => (
    sidebarOpen ? <a href={serializeView(app, { page: navKey })} onClick={(e)=>navClick(e, navKey)} style={{
      background: activeNav(navKey) ? B.sidebarAct : "none",
      color: activeNav(navKey) ? "#fff" : "rgba(255,255,255,0.55)",
      padding: nested ? "7px 20px 7px 52px" : "7px 20px 7px 36px",
      cursor: "pointer", fontSize: 12, textAlign: "left", width: "100%",
      borderLeft: activeNav(navKey) ? "3px solid "+B.cyan : "3px solid transparent",
      textDecoration:"none", display:"flex", alignItems:"center", gap:8, boxSizing:"border-box"
    }}><span>{label}</span><NavBadge n={badge} /></a> : null
  );

// badge: the total of the group's own badges, shown on the header while the
// group is closed (open, each item shows its own) and in the collapsed tooltip.
//
// Open (and the sidebar wide), a top-level group's header and items sit in one
// faint card, so the eye stays inside the group and can see where it ends.
// Closed, it is a plain header. Nested groups (Catalogs, Mappings …) are not
// boxed — they already sit inside their parent's card.
//
// The header's padding is one shorthand string, never shorthand plus
// paddingLeft: React writes an undefined longhand as "", which wipes the
// shorthand's left padding and pushed every closed header flush to the edge.
// Administrative's colour — the group and everything inside it, so the admin
// area reads as one place and stands apart from the amber working groups.
const ADMIN_RED = "#FF5A4E";
const NavGroup = ({ groupKey, label, icon, children, nested, badge }) => {
  const boxed = !nested && sidebarOpen && navOpen[groupKey];
  return (
  <div style={boxed ? { margin:"8px 8px 4px", borderRadius:8, overflow:"hidden",
                        background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.09)",
                        paddingBottom:4 } : undefined}>
    {sidebarOpen ? (
      <button onClick={()=>toggleNav(groupKey)} style={{
        background: "none", border: "none",
        color: "rgba(255,255,255,0.5)",
        padding: nested ? "7px 20px 7px 36px" : boxed ? "7px 11px" : "7px 20px", cursor: "pointer", fontSize: 11,
        textAlign: "left", width: "100%",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        textTransform: "uppercase", letterSpacing: "0.07em", fontWeight: 600,
        marginTop: boxed ? 0 : 8
      }}>
        <span style={{ display:"flex", alignItems:"center", gap:6 }}>{icon} {label}</span>
        <span style={{ display:"flex", alignItems:"center", gap:8 }}>
          {!navOpen[groupKey] && <NavBadge n={badge} />}
          <span style={{ fontSize: 10, opacity: 0.7, marginRight: 4 }}>{navOpen[groupKey] ? "▲" : "▼"}</span>
        </span>
      </button>
    ) : (
      // When collapsed show ONLY the top-level group icon — click to expand
      // the sidebar and open the group (sub-items stay hidden while collapsed).
      <button onClick={()=>{ setSidebarOpen(true); if(!navOpen[groupKey]) toggleNav(groupKey); }} title={label + (badge > 0 ? ` — ${badge} waiting` : "")} style={{
        background: "none", border: "none", color: "rgba(255,255,255,0.7)",
        padding: "9px 0", cursor: "pointer", width: "100%",
        display: "flex", alignItems: "center", justifyContent: "center",
        borderLeft: "3px solid transparent"
      }}>
        {icon}
      </button>
    )}
    {sidebarOpen && navOpen[groupKey] && <div>{children}</div>}
  </div>
  );
};

  return (
    <AppContext.Provider value={appCtx}>
    <AuthContext.Provider value={{ api, currentUser, role }}>
      {/* ── Impersonation banner (real admins only) ── */}
      {impersonateUser && realIsAdmin && (
        <div style={{ position:"fixed", top:12, left:"50%", transform:"translateX(-50%)", zIndex:1000, background:"#7a1fa2", color:"#fff", padding:"8px 16px", borderRadius:999, boxShadow:"0 4px 16px rgba(0,0,0,0.3)", display:"flex", alignItems:"center", gap:12, fontSize:13, fontWeight:600 }}>
          <span>🧪 Testing as {effectiveUser.name} ({effectiveUser.role})</span>
          <button onClick={stopImpersonate} style={{ background:"rgba(255,255,255,0.25)", border:"none", color:"#fff", borderRadius:999, padding:"3px 12px", cursor:"pointer", fontSize:12, fontWeight:600 }}>Exit</button>
        </div>
      )}

      {/* ── "Test as user" picker (real admins only) ── */}
      {impersonatePicker && realIsAdmin && (<>
        <div onClick={()=>setImpersonatePicker(false)} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.4)", zIndex:1100 }} />
        <div style={{ position:"fixed", top:"12%", left:"50%", transform:"translateX(-50%)", zIndex:1101, width:420, maxWidth:"92vw", maxHeight:"70vh", background:"#fff", borderRadius:12, boxShadow:"0 12px 40px rgba(0,0,0,0.3)", display:"flex", flexDirection:"column", overflow:"hidden" }}>
          <div style={{ padding:"14px 16px", borderBottom:"1px solid var(--color-border-tertiary)", fontWeight:600, fontSize:14 }}>Test as another user</div>
          <div style={{ padding:10 }}>
            <input autoFocus placeholder="Search users..." value={impQuery} onChange={e=>setImpQuery(e.target.value)}
              style={{ width:"100%", padding:"8px 10px", borderRadius:8, border:"1px solid var(--color-border-secondary)", fontSize:13, boxSizing:"border-box" }} />
          </div>
          <div style={{ overflowY:"auto" }}>
            {impUsers
              .filter(u => !impQuery || (u.FullName||"").toLowerCase().includes(impQuery.toLowerCase()) || (u.Email||"").toLowerCase().includes(impQuery.toLowerCase()))
              .map(u => (
                <button key={u.id} onClick={()=>startImpersonate(u)}
                  style={{ display:"flex", justifyContent:"space-between", alignItems:"center", width:"100%", padding:"10px 16px", background:"none", border:"none", borderBottom:"0.5px solid var(--color-border-tertiary)", cursor:"pointer", fontSize:13, textAlign:"left" }}
                  onMouseEnter={e=>e.currentTarget.style.background="var(--color-background-secondary)"} onMouseLeave={e=>e.currentTarget.style.background="none"}>
                  <span style={{ fontWeight:500 }}>{u.FullName}</span>
                  <span style={{ fontSize:11, color:"var(--color-text-secondary)" }}>{u.Role}</span>
                </button>
              ))}
            {impUsers.length===0 && <div style={{ padding:16, fontSize:13, color:"var(--color-text-secondary)" }}>Loading users…</div>}
          </div>
          <div style={{ padding:10, borderTop:"1px solid var(--color-border-tertiary)", textAlign:"right" }}>
            <button onClick={()=>setImpersonatePicker(false)} style={{ padding:"7px 14px", borderRadius:8, border:"0.5px solid var(--color-border-secondary)", background:"none", cursor:"pointer", fontSize:13 }}>Cancel</button>
          </div>
        </div>
      </>)}

      <div style={{ display:"flex", height:"100vh", fontFamily:"var(--font-sans)", background:"var(--color-background-tertiary)", overflow:"hidden", position:"relative" }} onClick={()=>{ if(notifOpen)setNotifOpen(false); if(userMenuOpen)setUserMenuOpen(false); }}>
        
        {/* A one-record window has nowhere to navigate to, so the nav goes. */}
        <div style={{ width:slim?0:(sidebarOpen?226:52), minWidth:slim?0:(sidebarOpen?226:52), background:B.sidebar, display:slim?"none":"flex", flexDirection:"column", padding:"20px 0", boxSizing:"border-box", transition:"width 0.2s ease, min-width 0.2s ease", overflow:"hidden" }}>
          <div style={{ padding:"0 12px 14px", borderBottom:"0.5px solid rgba(255,255,255,0.1)", marginBottom:10, display:"flex", alignItems:"center", justifyContent:sidebarOpen?"flex-start":"center", gap:10, width:"100%", boxSizing:"border-box", overflow:"hidden" }}>
            <img src={mark} alt="" style={{ height:30, width:"auto", objectFit:"contain", flexShrink:0 }} />
            {sidebarOpen && <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:4, overflow:"hidden" }}>
              <img src={wordmark} alt={org("name")} style={{ height:15, width:"auto", flexShrink:0, objectFit:"contain", filter:"brightness(0) invert(1)" }} />
              <div style={{ fontSize:11, color:B.cyanMid, whiteSpace:"nowrap", textAlign:"center", textTransform:"uppercase" }}>{APPS.find(a=>a.id===app)?.tag}</div>
            </div>}
          </div>
          <div className="nav-scroll" ref={navScrollRef} onScroll={e => { navScrollTop.current = e.currentTarget.scrollTop; }} style={{ flex:1, minHeight:0, overflowY:"auto", overflowX:"hidden" }}>

            {app==="upm" && (<>
              <NavItem navKey="dashboard" label="Dashboard" icon={<MdSpaceDashboard size={18} color={B.cyan} />} />
              <NavItem navKey="action-center" label="Action Center" icon={<MdPlaylistAddCheck size={18} color={B.cyan} />} badge={actionCount || null} />
              <NavItem navKey="accounts"  label="Accounts"  icon={<MdManageAccounts size={18} color={B.cyan} />} />
              <NavItem navKey="all-loans" label="Loans"     icon={<MdAccountBalance size={18} color={B.cyan} />} />
              {/* Badges: open checklist items on Accrual / Non Accrual loans (the
                  page's Open count) and overdue covenant entries (any days late) —
                  both from getMonitoringCounts. */}
              <NavItem navKey="all-checklist" label="Closing Checklists" icon={<MdListAlt  size={18} color={B.cyan} />} badge={monCounts.checklist} />
              <NavItem navKey="all-covenant-calendar-visual" label="Covenant Calendar"  icon={<MdCalendarMonth size={18} color={B.cyan} />} badge={monCounts.covenants} />
              <NavItem navKey="all-borrowersguarantors" label="Borrowers/Guarantors" icon={<MdBusiness size={18} color={B.cyan} />} />
              <NavItem navKey="all-contacts" label="Contacts"  icon={<MdContactMail size={18} color={B.cyan} />} />
              <NavItem navKey="all-wftransactions" label="Pmt Posting" icon={<MdCurrencyExchange size={18} color={B.cyan} />} badge={monCounts.pmtposting} />
              <NavItem navKey="all-notes" label="Notes"  icon={<MdNotes size={18} color={B.cyan} />} />       
              <NavItem navKey="reports" label="Reports" icon={<BsDatabaseFillDown  size={18} color={B.cyan} />} />

              {/* ── MONITORING ──
                  The five registers, together: UCC and tax for portfolio
                  managers and admins, MCA and bank activity for the bank-feed
                  permission. Collapsed, its header carries the
                  total of the badges inside. Starts collapsed. */}
              {(role.canViewMonitoring || role.canViewBankFeeds) && (
                <NavGroup groupKey="monitoring" label="Monitoring" icon={<MdFindInPage size={15} color={B.amber} />}
                  badge={(role.canViewMonitoring ? (monCounts.ucc || 0) + (monCounts.searches || 0) + (monCounts.tax || 0) + (monCounts.news || 0) : 0)
                         + (role.canViewBankFeeds ? (monCounts.mca || 0) + (monCounts.bank || 0) : 0)}>
                  {role.canViewMonitoring && <NavChild navKey="ucc-register" label="UCC Filings" badge={monCounts.ucc} />}
                  {role.canViewMonitoring && <NavChild navKey="ucc-searches" label="UCC Searches" badge={monCounts.searches} />}
                  {role.canViewMonitoring && <NavChild navKey="tax-monitoring" label="Tax Monitoring" badge={monCounts.tax} />}
                  {role.canViewMonitoring && <NavChild navKey="news-monitor" label="News Monitor" badge={monCounts.news} />}
                  {role.canViewBankFeeds && <NavChild navKey="mca-monitor" label="MCA Monitor" badge={monCounts.mca} />}
                  {role.canViewBankFeeds && <NavChild navKey="bank-activity" label="Bank Activity" badge={monCounts.bank} />}
                </NavGroup>
              )}

              {/* ── OPEN TO ANYONE IN THE PORTFOLIO APP ──
                  This group used to be gated on role.canManageUsers, which made
                  it an administrator's area. It is not one: it holds Terms,
                  Draws, Legal Events, Covenants, the UCC register and tax
                  monitoring — the records a portfolio manager works from daily.
                  A PM without the user-management flag could not see any of it,
                  which is how the UCC Register ended up invisible to exactly the
                  people it was built for.

                  No gate is needed here at all. The whole block is already
                  inside {app==="upm"}, so reaching it means having the
                  portfolio app, and every page inside enforces its own
                  permissions server-side — getBorrowersGuarantors returns only
                  the last four of a TIN, and bank account numbers stay behind
                  canViewBankNumbers whoever opens the page. */}
              {(
                <NavGroup groupKey="tables" label="Tables" icon={<MdTableChart size={15} color={B.amber} />}
                  childItems={[
                    { key:"all-terms",  label:"Terms",             icon:<MdDescription size={16} color={B.amber} /> },
                    { key:"all-draws",  label:"Draws",             icon:<MdDraw size={16} color={B.amber} /> },
                    { key:"all-spmts",  label:"Scheduled Pmts",    icon:<MdSchedule size={16} color={B.amber} /> },
                    { key:"all-achcollections", label:"ACH Collections", icon:<MdPayments size={16} color={B.amber} /> },
                    { key:"all-rpmts",  label:"Received Payments", icon:<MdPayments size={16} color={B.amber} /> },
                    { key:"all-participant-spmts", label:"Participation Sched Pmts",    icon:<MdSchedule size={16} color={B.amber} /> },
                    { key:"all-participant-pmts",  label:"Participation Received Pmts", icon:<MdPayments size={16} color={B.amber} /> },
                    { key:"all-legal",  label:"Legal Events",      icon:<MdDescription size={16} color={B.amber} /> },
                    { key:"all-chargeoffs",  label:"Charge Offs",      icon:<MdMoneyOff size={16} color={B.amber} /> },
                    { key:"all-riskratings",  label:"Risk Ratings",      icon:<MdAssessment size={16} color={B.amber} /> },
                    { key:'all-rates', label:'Index Rates', icon:'📊' },
                    { key:'all-forwardrates', label:'Forward Rates', icon:'📈' },
                    { key:"all-bankaccounts",        label:"Bank Accounts",        icon:<MdAccountBalance size={16} color={B.amber} /> },
                    { key:"all-mcacompanies",        label:"MCA Companies",        icon:<MdMoneyOff size={16} color={B.amber} /> },
                  ]}>
                  <NavChild navKey="all-covenants" label="Covenants" /> 
                  <NavChild navKey="all-covenant-calendar" label="Covenant Calendar" />
                  <NavChild navKey="covenant-exceptions" label="Covenant Exceptions" />
                  <NavChild navKey="all-terms"  label="Terms" />
                  <NavChild navKey="all-draws"  label="Draws" />
                  <NavChild navKey="all-spmts"  label="Scheduled Pmts" />
                  <NavChild navKey="all-achcollections" label="ACH Collections" />
                  <NavChild navKey="all-rpmts"  label="Received Payments" />
                  {/* What we owe participants, and what has been paid to them. */}
                  <NavChild navKey="all-participant-spmts" label="Participation Sched Pmts" />
                  <NavChild navKey="all-participant-pmts"  label="Participation Received Pmts" />
                  <NavChild navKey="all-legal"  label="Legal Events" />
                  <NavChild navKey="all-chargeoffs"  label="ChargeOffs" />
                  <NavChild navKey="all-riskratings"  label="Risk Ratings" />
                  <NavChild navKey="all-rates"  label="Index Rates" />
                  <NavChild navKey="all-forwardrates"  label="Forward Rates" />    
                  <NavChild navKey="all-bankaccounts" label="Bank Accounts" />
                  <NavChild navKey="all-mcacompanies" label="MCA Companies" />
          
                </NavGroup>
              )}

              <NavGroup groupKey="analytics" label="Analytics" icon={<MdInsights size={15} color={B.amber} />}
                childItems={[
                  { key:"portfolio-balance", label:"Portfolio Balance", icon:<BsBarChartFill size={16} color={B.amber} /> },
                  { key:"portfolio-performance", label:"Portfolio Performance", icon:<BsBarChartFill size={16} color={B.amber} /> },
                  { key:"stratification", label:"Stratification", icon:<BsBarChartFill size={16} color={B.amber} /> },
                  { key:"collateral-analytics", label:"Collateral", icon:<BsBarChartFill size={16} color={B.amber} /> },
                  { key:"draw-forecast", label:"Draw Forecast", icon:<BsBarChartFill size={16} color={B.amber} /> },
                  { key:"forward-curves", label:"Forward Curves", icon:<BsBarChartFill size={16} color={B.amber} /> },
                  { key:"industry-closings", label:"Industry Closings", icon:<BsBarChartFill size={16} color={B.amber} /> },
                  // The borrowers' bank accounts, as opposed to Internal Bank
                  // Accts below, which is the lender's own. Same nav group, opposite
                  // side of the relationship, so the labels have to carry it.
                  { key:"client-bank-detail", label:"Client Bank Acct Detail", icon:<BsBarChartFill size={16} color={B.amber} /> },
                  // Administrators only — it reads the firm's operating accounts,
                  // not just the collection accounts the Pmt Posting screen shows.
                  ...(role.isAdmin ? [{ key:"bank-transactions", label:"Internal Bank Accts", icon:<BsBarChartFill size={16} color={B.amber} /> }] : []),
                ]}>
                <NavChild navKey="portfolio-balance" label="Portfolio Balance" />
                <NavChild navKey="portfolio-performance" label="Portfolio Performance" />
                <NavChild navKey="stratification" label="Stratification" />
                <NavChild navKey="collateral-analytics" label="Collateral" />
                <NavChild navKey="draw-forecast" label="Draw Forecast" />
                <NavChild navKey="forward-curves" label="Forward Curves" />
                <NavChild navKey="industry-closings" label="Industry Closings" />
                <NavChild navKey="client-bank-detail" label="Client Bank Acct Detail" />
                {role.isAdmin && <NavChild navKey="bank-transactions" label="Internal Bank Accts" />}
              </NavGroup>

              {biGroups.map(g=>(
                <NavGroup key={g.category} groupKey={"bicat:"+g.category} label={g.category} icon={<BsBarChartFill size={15} color="#ffb20d"/>}
                  childItems={g.items.map(d=>({ key:"bi:"+d.id, label:d.name, icon:<BsBarChartFill size={16} color="#ffb20d"/> }))}>
                  {g.items.map(d=><NavChild key={d.id} navKey={"bi:"+d.id} label={d.name} />)}
                </NavGroup>
              ))}

              {/* The group opens for a servicer OR an administrator, because Bank
                  Import lives here and is admin-gated while the other three are
                  servicer-gated. Each child therefore carries its OWN condition,
                  matching the route guard further down — a nav entry that renders
                  nothing when clicked is worse than one that is not offered. */}
              {(role.isservicer || role.isAdmin) && (<NavGroup groupKey="servicing" label="Servicing" icon={<MdSchedule size={15} color={B.amber} />}>
                  {role.isservicer && <NavChild navKey="update-scheduled-payments" label="Update Sched Pmts" />}
                  {role.isservicer && <NavChild navKey="invoice-batch" label="Invoice Statements" />}
                  {role.isservicer && <NavChild navKey="all-statements" label="Interest Statements" />}
                  {/* The other three GENERATE documents; this one decides which of
                      them a borrower may see, so it sits below them in the order
                      the work actually happens. Servicer or administrator, matching
                      getAllStatements and updateStatement. */}
                  {(role.isservicer || role.isAdmin) && <NavChild navKey="publish-statements" label="Publish Statements" />}
                  {/* Publishing makes a document visible; this tells the borrower it is
                      there, so it sits immediately after. ADMIN-ONLY, unlike its
                      neighbour: this is the only screen in ACE that writes to an
                      address outside the firm, and previewInvoiceNotices /
                      sendInvoiceNotices both require canManageUsers — a looser gate
                      here would render the page and then 403 on load. */}
                  {role.canManageUsers && <NavChild navKey="client-invoice-notices" label="Client Invoice Notices" />}
                  {/* Loading a borrower's bank file by hand is servicing work, not
                      administration — it is the manual counterpart to the Plaid
                      feed, so a servicer owns it. Administrators keep the access
                      they had. The five endpoints behind it were widened to match
                      (each endpoint's index.js now asks u.isServicer || u.isAdmin);
                      NOTE THE CASING — the server flag is isServicer, this one is
                      role.isservicer, and they are not the same spelling. */}
                  {(role.isservicer || role.isAdmin) && <NavChild navKey="bank-import" label="Bank Import" />}
                  {/* Directly under Bank Import, because it is the same job seen from
                      the other end: the importer asks "which account is this?" at
                      upload time, and this page answers it for every stream that
                      arrived without one — migrated history and the Plaid feed
                      included. Same gate, for the same reason. */}
                  {(role.isservicer || role.isAdmin) && <NavChild navKey="bank-mapping" label="Bank Acct Mapping" />}
                </NavGroup>
              )}

              </>)}
            {app==="collateral" && (<>
              <NavItem navKey="collateral-portfolio" label="Portfolio" icon={<MdSpaceDashboard size={18} color={B.cyan} />} />
              <NavItem navKey="collateral-dashboard" label="Borrower Dashboard" icon={<MdAssessment size={18} color={B.cyan} />} />
              <NavItem navKey="collateral-home" label="Borrowing Bases" icon={<MdAccountBalance size={18} color={B.cyan} />} />
              <NavItem navKey="collateral-insights" label="Insights" icon={<MdInsights size={18} color={B.cyan} />} />
              {/* add Collateral Management nav items here as you build them */}
            </>)}

            {app==="sales" && (<>
              <NavItem navKey="sales-dashboard" label="Dashboard" icon={<MdSpaceDashboard size={18} color={B.cyan} />} />
              <NavItem navKey="sales-followups" label="Follow-Ups" icon={<MdEventRepeat size={18} color={B.cyan} />} />
              <NavItem navKey="sales-referral-sources" label="Referral Sources" icon={<MdShare size={18} color={B.cyan} />} />
              <NavItem navKey="sales-leads" label="Leads" icon={<MdPersonAdd size={18} color={B.cyan} />} />
              <NavItem navKey="sales-accounts" label="Accounts" icon={<MdManageAccounts size={18} color={B.cyan} />} />
              <NavItem navKey="sales-opportunities" label="Opportunities" icon={<MdTrendingUp size={18} color={B.cyan} />} />
              <NavItem navKey="sales-contacts" label="Contacts" icon={<MdContactMail size={18} color={B.cyan} />} />
              {/* Email Review: everyone in the sales app. Administrators and BDO
                  managers see every unmatched address; everyone else sees the
                  addresses on mail they sent or received, and clears their own.
                  The API does the scoping (getEmailActivity / resolveEmailAddress),
                  so the badge is each person's own count.

                  Cyan now, as the earlier note here said it should be once BDOs
                  clear their own queue: it is part of the normal course of
                  business rather than an administrator's exception list. */}
              {role.canAccessSales&&<NavItem navKey="sales-email-triage" label="Email Review" icon={<MdMarkEmailUnread size={18} color={B.cyan} />} badge={emailQueue} />}
              <NavGroup groupKey="sales-analytics-grp" label="Analytics" icon={<MdInsights size={15} color={B.amber} />}>
                <NavGroup groupKey="sales-analytics-pipeline" label="Pipeline" icon={<MdInsights size={15} color={B.amber} />} nested>
                  <NavChild navKey="sales-analytics" label="Pipeline Analytics" nested />
                  <NavChild navKey="sales-opportunity-sources" label="Opportunity Sources" nested />
                  <NavChild navKey="sales-fallout" label="Fallout Analysis" nested />
                </NavGroup>
                <NavGroup groupKey="sales-analytics-employee" label="Employee" icon={<MdGroups size={15} color={B.amber} />} nested>
                  <NavChild navKey="sales-by-employee" label="By Employee" nested />
                  <NavChild navKey="sales-monthly-activity" label="Monthly Activity" nested />
                  <NavChild navKey="sales-leads-by-month" label="Leads by Month" nested />
                  <NavChild navKey="sales-opp-by-month" label="Opportunity by Month" nested />
                  <NavChild navKey="sales-lead-to-opp" label="Lead to Opportunity" nested />
                  <NavChild navKey="sales-opp-to-ts" label="Opp to Term Sheet" nested />
                  <NavChild navKey="sales-ts-to-funding" label="TS Issued to TS Signed" nested />
                  <NavChild navKey="sales-ts-signed-funding" label="TS Signed to Funding" nested />
                  <NavChild navKey="sales-opp-ts-month" label="Opp TS by Month" nested />
                  <NavChild navKey="sales-fallout-detail" label="Fallout Detail" nested />
                </NavGroup>
              </NavGroup>
            </>)}
          </div>

          {/* ── Administrative, pinned ──
              Below the scrolling nav, above the field guide, behind a divider:
              everything above the line is the day's work, this is setting the
              system up. Pinned, it never moves when Tables or Analytics opens.
              Open, it grows upward (the list above shrinks and scrolls) and
              stops at 45% of the screen, scrolling inside itself beyond that,
              so it can never bury the work groups on a laptop. */}
          {app==="upm" && role.isAdmin && !slim && (
            <div className="nav-scroll" style={{ flexShrink:0, maxHeight:"45vh", overflowY:"auto", overflowX:"hidden",
                          borderTop:"1px solid rgba(255,255,255,0.14)", marginTop:6, paddingTop:2 }}>
              {/* Administrators only — the whole group, Audit Log included. It used
                  to open for anyone with canViewAudit, which every Standard User
                  has, so they saw an Administrative heading holding one item. */}
              {(
                <NavGroup groupKey="admin" label="Administrative" icon={<MdAdminPanelSettings size={15} color={ADMIN_RED} />}
                  childItems={[
                    role.isAdmin        && { key:"audit", label:"Audit Log",       icon:<MdHistory size={16} color={ADMIN_RED} /> },
                    role.isAdmin        && { key:"usage", label:"Usage",           icon:<MdInsights size={16} color={ADMIN_RED} /> },
                    role.canManageUsers && { key:"users",           label:"User Management",     icon:<MdSettings size={16} color={ADMIN_RED} /> },
                    role.canManageUsers && { key:"client-portal",   label:"Client Portal Login", icon:<MdManageAccounts size={16} color={ADMIN_RED} /> },
                    role.canManageUsers && { key:"all-bi-dashboards", label:"Power BI Dashboards", icon:<BsBarChartFill size={16} color={ADMIN_RED} /> },
                    role.canManageUsers && { key:"data-model", label:"Data Model", icon:<MdShare size={16} color={ADMIN_RED} /> },

                  ].filter(Boolean)}>
                  {role.isAdmin&&<NavChild navKey="audit" label="Audit Log" />}
                  {role.isAdmin&&<NavChild navKey="usage" label="Usage" />}
                  {role.canManageUsers&&<NavChild navKey="users" label="User Management" />}
                  {role.canManageUsers&&<NavChild navKey="client-portal" label="Client Portal Login" />}
                  {role.canManageUsers&&<NavChild navKey="all-bi-dashboards" label="Power BI Dashboards" />}
                  {role.canManageUsers&&<NavChild navKey="data-model" label="Data Model" />}

                  {/* WHAT A THING IS vs HOW IT IS MATCHED. A catalog is the list of
                      things that exist; a mapping says which of them applies where.
                      They were interleaved in one flat list of nine, so the pairing
                      was invisible and the two Checklist entries read as duplicates. */}
                  {role.canManageUsers && (<NavGroup groupKey="catalogs" label="Catalogs" icon={<MdMenuBook size={15} color={ADMIN_RED} />} nested>
                      <NavChild navKey="all-funds" label="Fund Catalog" nested />
                      <NavChild navKey="all-covenant-catalog" label="Covenant Catalog" nested />
                      <NavChild navKey="all-checklist-catalog" label="Checklist Catalog" nested />
                    </NavGroup>
                  )}

                  {(role.canManageUsers || role.isAdmin) && (<NavGroup groupKey="mappings" label="Mappings" icon={<MdTableChart size={15} color={ADMIN_RED} />} nested>
                      {role.canManageUsers && <NavChild navKey="all-checklist-mapping" label="Checklist Mapping" nested />}
                      {/* Renamed from "Pmt Posting Rules". The nav KEY stays
                          all-pmtpostingrules: it is the route, and any bookmark or
                          saved link uses it. Only what a person reads changes. */}
                      {role.isAdmin && <NavChild navKey="all-pmtpostingrules" label="Pmt Posting Mapping" nested />}
                    </NavGroup>
                  )}

                  {role.canManageUsers && (<NavGroup groupKey="integrations" label="Integrations" icon={<MdSettings size={15} color={ADMIN_RED} />} nested>
                      <NavChild navKey="integration-wf" label="Wells Fargo" nested />
                      <NavChild navKey="integration-plaid" label="Plaid" nested />
                      <NavChild navKey="integration-m365mail" label="Microsoft 365 Mail" nested />
                      <NavChild navKey="integration-notifications" label="Notification Email" nested />
                      {/* The BORROWER-facing mailbox. Deliberately a separate row from
                          Notification Email: that one is fenced to the lender's own domain,
                          and widening it to reach clients would remove that fence from
                          every internal notice too. Configuration only — sending is on
                          Client Invoice Notices, under Statements. */}
                      <NavChild navKey="integration-clientmail" label="Client Mail" nested />
                      {/* UCC searching, filing and monitoring. Read-only while enabled;
                          ordering anything is a separate, person-initiated action. */}
                      <NavChild navKey="integration-csc" label="CSC (UCC)" nested />
                      {/* Federal tax standing from IRS transcripts, under a signed
                          Form 8821. Read-only while enabled; ordering a report is
                          billable and person-initiated. */}
                      <NavChild navKey="integration-taxguard" label="Tax Guard" nested />
                      {/* The free news index behind News Monitor. No key; settings only. */}
                      <NavChild navKey="integration-news" label="News (Serper)" nested />
                    </NavGroup>
                  )}
                </NavGroup>
              )}
            </div>
          )}

          {/* ── Field guide ──
              Pinned below the scrolling nav rather than inside it: it is not a
              place in the app, it is the manual for the app, and a new joiner
              should be able to find it without scrolling past twenty analytics
              pages.

              A plain anchor to a real static file, opened in a new tab: it is
              the same document handed out at onboarding, it prints, and it keeps
              working even if the SPA is broken — which is exactly when somebody
              goes looking for the manual. Collapsed sidebar shows the icon
              alone. */}
          {FIELD_GUIDES[app] && !slim && (
            <a href="#" onClick={e => { e.preventDefault();
                 openGuide(authState.token, FIELD_GUIDES[app].name, FIELD_GUIDES[app].label); }}
              title={"Field Guide — how " + (APPS.find(a=>a.id===app)?.name || "this app") + " works"}
              style={{ display:"flex", alignItems:"center", gap:10, textDecoration:"none",
                       margin:"8px 10px 0", padding:"9px 10px", borderRadius:8,
                       justifyContent: sidebarOpen ? "flex-start" : "center",
                       border:"0.5px solid rgba(255,255,255,0.16)",
                       background:"rgba(255,255,255,0.04)", color:"rgba(255,255,255,0.82)" }}
              onMouseEnter={e=>{ e.currentTarget.style.background="rgba(18,181,219,0.18)";
                                 e.currentTarget.style.color="#fff"; }}
              onMouseLeave={e=>{ e.currentTarget.style.background="rgba(255,255,255,0.04)";
                                 e.currentTarget.style.color="rgba(255,255,255,0.82)"; }}>
              <MdMenuBook size={18} color={B.cyan} style={{ flexShrink:0 }} />
              {sidebarOpen && <span style={{ fontSize:13, fontWeight:500, whiteSpace:"nowrap" }}>{FIELD_GUIDES[app].label}</span>}
            </a>
          )}
        </div>
       
        {/* Floating collapse/expand toggle — straddles the sidebar/content edge so it never blocks nav icons.
            Hidden in a slim window: there is no sidebar left for it to collapse. */}
        {!slim && <button onClick={()=>setSidebarOpen(o=>!o)} title={sidebarOpen?"Collapse menu":"Expand menu"}
          style={{ position:"absolute", top:60, left:sidebarOpen?226:52, transform:"translateX(-50%)", zIndex:200,
                   display:"flex", alignItems:"center", justifyContent:"center", width:26, height:26, borderRadius:"50%",
                   background:B.sidebar, border:"0.5px solid rgba(255,255,255,0.3)", color:"rgba(255,255,255,0.85)",
                   cursor:"pointer", padding:0, boxShadow:"0 1px 5px rgba(0,0,0,0.35)", transition:"left 0.2s ease" }}>
          {sidebarOpen ? <MdChevronLeft size={18} /> : <MdChevronRight size={18} />}
        </button>}

        <div style={{ flex:1, overflow:"auto", padding:"0 28px 28px 28px", boxSizing:"border-box", position:"relative" }}>
          <div style={{ position:"sticky", top:0, zIndex:100, background:B.sidebar, padding:"0 24px", height:73, display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16, marginLeft:-28, marginRight:-28, boxShadow:"0 2px 8px rgba(0,0,0,0.15)", borderLeft:"0.5px solid rgba(255,255,255,0.1)" }}>
            <div style={{ display:"flex", alignItems:"center", gap:8 }}>
              {/* Back button */}
              {/* No back button in a slim window — it was opened onto one record
                  and has no history to step back through. */}
              {!slim && ["account","loan","spmt","sales-account","referral-source"].includes(view.page)&&(
                <button onClick={()=>{
                  if(view.page==="loan") go("account",{accountid:view.accountid});
                  else if(view.page==="account") go("accounts");
                  else if(view.page==="spmt") go("loan",{accountid:view.accountid,loanid:view.loanid});
                  else if(view.page==="sales-account") go("sales-accounts");
                  else if(view.page==="referral-source") go("sales-referral-sources");
                }} style={{ background:"rgba(255,255,255,0.2)", border:"none", borderRadius:6, padding:"4px 10px", cursor:"pointer", fontSize:12, color:"#fff", marginRight:4 }}>← Back</button>
              )}
              {/* Breadcrumb + title */}
              <div style={{ display:"flex", alignItems:"center", gap:6, fontSize:13 }}>
                {view.page==="all-statements"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Interest Statements</span>}
                {view.page==="publish-statements"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Publish Statements</span>}
                {view.page==="client-invoice-notices"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Client Invoice Notices</span>}
                {view.page==="dashboard"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Dashboard</span>}
                {view.page==="action-center"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Action Center</span>}
                {view.page==="overdue-payments"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Overdue and Upcoming Payments</span>}
                {view.page==="owed-payments"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Owed and Upcoming Payments</span>}
                {view.page==="collateral-portfolio"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Collateral Portfolio</span>}
                {view.page==="collateral-dashboard"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Borrower Dashboard</span>}
                {view.page==="sales-dashboard"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Sales Dashboard</span>}
                {view.page==="sales-leads"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Leads</span>}
                {view.page==="sales-opportunities"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Opportunities</span>}
                {view.page==="sales-pipeline"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Sales Dashboard</span>}
                {view.page==="sales-analytics"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Sales Analytics</span>}
                {view.page==="sales-opportunity-sources"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Opportunity Sources</span>}
                {view.page==="sales-fallout"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Fallout Analysis</span>}
                {view.page==="sales-by-employee"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>By Employee</span>}
                {view.page==="sales-monthly-activity"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Monthly Activity</span>}
                {view.page==="sales-leads-by-month"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Leads by Month</span>}
                {view.page==="sales-lead-to-opp"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Lead to Opportunity</span>}
                {view.page==="sales-opp-to-ts"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Opportunity to Term Sheet</span>}
                {view.page==="sales-opp-by-month"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Opportunity by Month</span>}
                {view.page==="sales-ts-to-funding"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>TS Issued to TS Signed</span>}
                {view.page==="sales-ts-signed-funding"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>TS Signed to Funding</span>}
                {view.page==="sales-opp-ts-month"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Opp TS by Month</span>}
                {view.page==="sales-fallout-detail"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Fallout Detail</span>}
                {view.page==="sales-accounts"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Accounts</span>}
                {view.page==="sales-contacts"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Contacts</span>}
                {view.page==="sales-email-triage"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Email Review</span>}
                {view.page==="integration-m365mail"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Microsoft 365 Email Capture</span>}
                {view.page==="sales-account"&&<>
                  <span onClick={()=>go("sales-accounts")} style={{ color:"rgba(255,255,255,0.75)", cursor:"pointer", fontSize:13 }}>Accounts</span>
                  <span style={{ color:"rgba(255,255,255,0.5)" }}>›</span>
                  <span style={{ color:"#fff", fontWeight:600, fontSize:13 }}>{view.companyname||"Account"}</span>
                </>}
                {view.page==="sales-referral-sources"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Referral Sources</span>}
                {view.page==="referral-source"&&<>
                  <span onClick={()=>go("sales-referral-sources")} style={{ color:"rgba(255,255,255,0.75)", cursor:"pointer", fontSize:13 }}>Referral Sources</span>
                  <span style={{ color:"rgba(255,255,255,0.5)" }}>›</span>
                  <span style={{ color:"#fff", fontWeight:600, fontSize:13 }}>{view.companyname||"Referral Source"}</span>
                </>}
                {view.page==="collateral-home"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Borrowing Bases</span>}
                {view.page==="collateral-bbc"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Borrowing Base</span>}
                {view.page==="collateral-insights"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Insights</span>}
                {view.page==="accounts"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Accounts</span>}
                {view.page==="account"&&<>
                  <span onClick={()=>go("accounts")} style={{ color:"rgba(255,255,255,0.75)", cursor:"pointer", fontSize:13 }}>Accounts</span>
                  <span style={{ color:"rgba(255,255,255,0.5)" }}>›</span>
                  <span style={{ color:"#fff", fontWeight:600, fontSize:13 }}>{view.companyname||"Account"}</span>
                </>}
                {view.page==="loan"&&<>
                  <span onClick={()=>go("accounts")} style={{ color:"rgba(255,255,255,0.75)", cursor:"pointer", fontSize:13 }}>Accounts</span>
                  <span style={{ color:"rgba(255,255,255,0.5)" }}>›</span>
                  <span onClick={()=>go("account",{accountid:view.accountid,companyname:view.companyname})} style={{ color:"rgba(255,255,255,0.75)", cursor:"pointer", fontSize:13 }}>{view.companyname||"Account"}</span>
                  <span style={{ color:"rgba(255,255,255,0.5)" }}>›</span>
                  <span style={{ color:"#fff", fontWeight:600, fontSize:13 }}>{view.loannumber||"Loan"}</span>
                </>}
                {view.page==="spmt"&&<><span style={{ color:"rgba(255,255,255,0.75)", fontSize:13 }}>Scheduled Payment</span></>}
                {view.page==="all-loans"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Loans</span>}
                {view.page==="all-terms"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Terms</span>}
                {view.page==="all-draws"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Draws</span>}
                {view.page==="all-spmts"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Scheduled Payments</span>}
                {view.page==="all-achcollections"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>ACH Collections</span>}
                {view.page==="all-rpmts"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Received Payments</span>}
                {view.page==="all-participant-spmts"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Participation Scheduled Payments</span>}
                {view.page==="all-participant-pmts"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Participation Received Payments</span>}
                {view.page==="all-contacts"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Contacts</span>}
                {view.page==="all-legal"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Legal Events</span>}
                {view.page==="ucc-register"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>UCC Register</span>}
                {view.page==="ucc-searches"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>UCC Searches</span>}
                {view.page==="tax-monitoring"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Tax Monitoring</span>}
                {view.page==="news-monitor"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>News Monitor</span>}
                {view.page==="mca-monitor"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>MCA Monitor</span>}
                {view.page==="bank-activity"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Bank Activity</span>}
                {view.page==="all-mcacompanies"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>MCA Companies</span>}
                {view.page==="taxguard-matching"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Tax Guard Matching</span>}
                {view.page==="all-chargeoffs"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>ChargeOffs</span>}
                {view.page==="all-riskratings"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Risk Ratings</span>}
                {view.page==="all-rates"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Index Rates</span>}
                {view.page==="all-forwardrates"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Forward Rates</span>}
                {view.page==="all-pmtpostingrules"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Payment Posting Mapping</span>}
                {view.page==="update-scheduled-payments"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Update Scheduled Payments</span>}   
                {view.page==="invoice-batch"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Invoice Statements</span>}                  
                {view.page==="all-notes"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Notes</span>}               
                {view.page==="all-funds" && <span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Fund Catalog</span>}
                {view.page==="audit"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Audit Log</span>}
                {view.page==="usage"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Usage</span>}
                {view.page==="users"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>User Management</span>}
                {view.page==="client-portal"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Client Portal Login</span>}
                {view.page==="all-covenants"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Covenants</span>}
                {view.page==="all-covenant-calendar"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Covenant Calendar</span>}
                {view.page==="all-covenant-catalog"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Covenant Catalog</span>}
                {view.page==="all-bi-dashboards"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Power BI Dashboards</span>}
                {view.page==="collateral-analytics"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Collateral Analytics</span>}
                {view.page==="draw-forecast"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Draw Forecast</span>}
                {view.page==="stratification"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Stratification</span>}
                {view.page==="portfolio-balance"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Monthly Portfolio Balance</span>}
                {view.page==="portfolio-performance"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Portfolio Performance</span>}
                {view.page==="forward-curves"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Forward Curves</span>}
                {view.page==="industry-closings"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Industry Closings</span>}
                {view.page==="bank-transactions"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Internal Bank Accounts</span>}
                {view.page==="bank-import"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Bank Import</span>}
                {view.page==="bank-mapping"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Bank Acct Mapping</span>}
                {view.page==="client-bank-detail"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Client Bank Acct Detail</span>}
                {view.page==="data-model"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Data Model</span>}
                {view.page==="reports"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Reports</span>}
                {view.page==="integration-wf" && <span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Wells Fargo Integration</span>}
                {view.page==="integration-plaid" && <span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Plaid Integration</span>}
              {view.page==="integration-notifications" && <span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Notification Email</span>}
              {view.page==="integration-clientmail" && <span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Client Mail</span>}
              {view.page==="integration-csc" && <span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>CSC — UCC Business Direct</span>}
              {view.page==="integration-taxguard" && <span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Tax Guard</span>}
              {view.page==="integration-news" && <span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>News (Serper)</span>}
                {view.page==="all-wftransactions"&& <span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>WF Transactions</span>}
                {view.page==="all-bankaccounts"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Bank Accounts</span>}
                {view.page==="all-borrowersguarantors"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Borrowers/Guarantors</span>}
                {view.page==="all-covenant-calendar-visual"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Covenant Calendar</span>}
                {view.page==="all-checklist-catalog"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Checklist Catalog</span>}
                {view.page==="all-checklist-mapping"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Checklist Mapping</span>}
                {view.page==="all-checklist"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Closing Checklists</span>}
                {view.page==="covenant-exceptions"&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>Covenant Exception</span>}
                {view.page?.startsWith("bi:")&&<span style={{ color:"#fff", fontWeight:600, fontSize:15 }}>{(biDashboards.find(d=>("bi:"+d.id)===view.page)||{}).name||"Dashboard"}</span>}
                
              </div>
            </div>
              {/* Close. window.close() is permitted here because the window was
                  opened by script, which is also why this is the only place the
                  button appears. */}
              {slim && (
                <button onClick={()=>window.close()} title="Close this window"
                  style={{ background:"rgba(255,255,255,0.15)", border:"0.5px solid rgba(255,255,255,0.35)",
                           color:"#fff", borderRadius:8, width:32, height:32, cursor:"pointer",
                           fontSize:15, lineHeight:1, display:"flex", alignItems:"center",
                           justifyContent:"center", padding:0, flexShrink:0 }}>✕</button>
              )}
              {/* App switcher, notifications and the account menu are all ways
                  OUT of this record. A one-record window should not offer them. */}
              <div onClick={e=>e.stopPropagation()} style={{ display:slim?"none":"flex", alignItems:"center", gap:14 }}>
              <AppSwitcher currentApp={app} user={effectiveUser}
                onSelect={(id)=>{ setApp(id); go(DEFAULT_PAGE[id]); }} />

              {/* ── The bell ──────────────────────────────────────────────
                  NotifCenter has existed in shared/components.js since the
                  beginning and was never imported anywhere — the state was
                  fetched, `notifOpen` was only ever set to FALSE, and the
                  component had no mount point. It has one now, because
                  notifications finally have a producer.

                  Clicking one marks it read and, if it carries a Link, goes
                  there — which is the same hash link the email uses, so the
                  two routes into a record are literally the same string. */}
              <NotifCenter
                notifs={notifs}
                open={notifOpen}
                onToggle={()=>setNotifOpen(o=>!o)}
                onReadAll={async ()=>{ try { await api.post("markNotificationRead",{readAll:true}); } catch(e){} loadNotifs(); }}
                onRead={async (id)=>{
                  const n = notifs.find(x=>String(x.Id||x.id)===String(id));
                  try { await api.post("markNotificationRead",{ id }); } catch(e){}
                  loadNotifs();
                  if (n && n.Link) {
                    // The Link is a full URL in the email and a hash here. Take
                    // only the hash so an absolute link from another environment
                    // cannot navigate this one away to a different deployment.
                    const h = String(n.Link);
                    const hash = h.slice(h.indexOf("#"));
                    if (hash.startsWith("#")) {
                      const parsed = parseHash(hash);
                      if (parsed) { setNotifOpen(false); setApp(parsed.app); setView(parsed.view); }
                    }
                  }
                }}
                onDismiss={async (id)=>{ try { await api.post("markNotificationRead",{ id }); } catch(e){} loadNotifs(); }} />

              {/* ── User avatar + account menu ── */}
              <div style={{ position:"relative" }}>
                <button onClick={()=>setUserMenuOpen(o=>!o)} title={currentUser.name}
                  style={{ width:34, height:34, borderRadius:"50%", border:"2px solid rgba(255,255,255,0.5)", background:B.cyan, color:"#fff", fontSize:13, fontWeight:600, cursor:"pointer", padding:0, display:"flex", alignItems:"center", justifyContent:"center", overflow:"hidden" }}>
                  {currentUser.photoUrl
                    ? <img src={currentUser.photoUrl} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }} />
                    : initials}
                </button>
                {userMenuOpen && (
                  <div style={{ position:"absolute", top:44, right:0, width:240, background:"#fff", borderRadius:10, boxShadow:"0 6px 24px rgba(0,0,0,0.18)", border:"0.5px solid var(--color-border-tertiary)", zIndex:300, overflow:"hidden" }}>
                    <div style={{ padding:16, display:"flex", flexDirection:"column", alignItems:"center", gap:8, borderBottom:"1px solid var(--color-border-tertiary)" }}>
                      <div style={{ width:56, height:56, borderRadius:"50%", background:B.cyan, color:"#fff", fontSize:20, fontWeight:600, display:"flex", alignItems:"center", justifyContent:"center", overflow:"hidden" }}>
                        {currentUser.photoUrl ? <img src={currentUser.photoUrl} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }} /> : initials}
                      </div>
                      <div style={{ fontSize:14, fontWeight:600, color:"#1a1a1a", textAlign:"center" }}>{currentUser.name}</div>
                      <RoleBadge role={currentUser.role} />
                      {currentUser.authType==="aad" && <div style={{ fontSize:11, color:"var(--color-text-secondary)" }}>⊞ Microsoft account</div>}
                    </div>
                    {realIsAdmin && (
                      <button onClick={openImpersonatePicker} style={{ width:"100%", padding:"11px 16px", background:"none", border:"none", borderBottom:"1px solid var(--color-border-tertiary)", cursor:"pointer", fontSize:13, fontWeight:500, color:"#1a1a1a", textAlign:"center" }}
                        onMouseEnter={e=>e.currentTarget.style.background="var(--color-background-secondary)"} onMouseLeave={e=>e.currentTarget.style.background="none"}>
                        🧪 Test as another user
                      </button>
                    )}
                    <button onClick={handleLogout} style={{ width:"100%", padding:"11px 16px", background:"none", border:"none", cursor:"pointer", fontSize:13, fontWeight:500, color:"#993C1D", textAlign:"center" }}
                      onMouseEnter={e=>e.currentTarget.style.background="#FAECE7"} onMouseLeave={e=>e.currentTarget.style.background="none"}>
                      Sign out
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>


          {/* Creating an account here saved it at stage Prospect, which this app
              filters out — so it vanished from the list it was created in. Accounts
              come from Sales; the button now explains that instead of the form. */}
          {modal&&modal.type==="account-add"&&(
            <AccountCreateNotice
              canGoToSales={!!role.canAccessSales}
              onGoToSales={()=>{ closeModal(); setApp("sales"); go(DEFAULT_PAGE["sales"]); }} />
          )}
          {modal&&modal.type==="account-edit"&&<AccountForm initial={{...modal.rec,id:modal.rec.id,companyname:modal.rec.companyname,companyphone:modal.rec.companyphone,companyemail:modal.rec.companyemail,status:modal.rec.status,street:modal.rec.street,city:modal.rec.city,state:modal.rec.state,country:modal.rec.country,account_manager:modal.rec.account_manager,accountnumber:modal.rec.accountnumber,industryid:modal.rec.industryid,website:modal.rec.website,box_folder_id:modal.rec.box_folder_id }} />}
          {modal&&modal.type==="account-view"&&<AccountForm initial={{...modal.rec,id:modal.rec.id,companyname:modal.rec.companyname||modal.rec.companyname,companyphone:modal.rec.companyphone,companyemail:modal.rec.companyemail,status:modal.rec.status,street:modal.rec.street,city:modal.rec.city,state:modal.rec.state,country:modal.rec.country,account_manager:modal.rec.account_manager,accountnumber:modal.rec.accountnumber,industryid:modal.rec.industryid,website:modal.rec.website,box_folder_id:modal.rec.box_folder_id,avgriskrating:modal.rec.avgriskrating}} readOnly />}
          {modal&&modal.type==="loan-add"&&<LoanForm accountid={modal.accountid} />}
          {modal&&modal.type==="loan-edit"&&<LoanForm initial={modal.rec} accountid={modal.rec.accountid} />}
          {modal&&modal.type==="loan-view"&&<LoanForm initial={modal.rec} accountid={modal.rec.accountid} readOnly />}
          {modal&&modal.type==="terms-add"&&<TermsForm loanid={modal.loanid} wide />}
          {modal&&modal.type==="terms-edit"&&<TermsForm initial={{...modal.rec, loanid:modal.rec.loanid||modal.rec.loanid}} loanid={modal.rec.loanid||modal.rec.loanid} wide />}
          {modal&&modal.type==="terms-view"&&<TermsForm initial={{...modal.rec, loanid:modal.rec.loanid||modal.rec.loanid}} loanid={modal.rec.loanid||modal.rec.loanid} wide readOnly />}
          {modal&&modal.type==="spmt-add"&&<SPmtForm loanid={modal.loanid} />}
          {modal&&modal.type==="spmt-edit"&&<SPmtForm initial={{...modal.rec, loanid:modal.rec.loanid||modal.rec.loanid}} loanid={modal.rec.loanid||modal.rec.loanid} wide />}
          {modal&&modal.type==="spmt-view"&&<SPmtForm initial={modal.rec} loanid={modal.rec.loanid} readOnly />}
          {modal&&modal.type==="rpmt-add"&&<RPmtForm spmtId={modal.spmtId} />}
          {modal&&modal.type==="rpmt-edit"&&<RPmtForm initial={modal.rec} spmtId={modal.rec.scheduledpmtid} />}
          {modal&&modal.type==="rpmt-view"&&<RPmtForm initial={modal.rec} spmtId={modal.rec.scheduledpmtid} readOnly />}
          {modal&&modal.type==="draw-add"&&<DrawForm loanid={modal.loanid} />}
          {modal&&modal.type==="draw-edit"&&<DrawForm initial={modal.rec} loanid={modal.rec.loanid} />}
          {modal&&modal.type==="draw-view"&&<DrawForm initial={modal.rec} loanid={modal.rec.loanid} readOnly />}
          {modal&&modal.type==="ach-add"&&<ACHCollectionForm loanid={modal.loanid} accountid={modal.accountid} />}
          {modal&&modal.type==="ach-edit"&&<ACHCollectionForm initial={modal.rec} loanid={modal.rec.loanid} accountid={modal.accountid} />}
          {modal&&modal.type==="ach-view"&&<ACHCollectionForm initial={modal.rec} loanid={modal.rec.loanid} accountid={modal.accountid} readOnly />}
          {modal&&modal.type==="lead-add"&&<LeadForm referralsourceid={modal.referralsourceid} />}
          {modal&&modal.type==="lead-edit"&&<LeadForm initial={modal.rec} />}
          {modal&&modal.type==="lead-view"&&<LeadForm initial={modal.rec} readOnly />}
          {modal&&modal.type==="opp-add"&&<OpportunityForm accountid={modal.accountid} />}
          {modal&&modal.type==="opp-edit"&&<OpportunityForm initial={modal.rec} accountid={modal.rec.accountid} />}
          {modal&&modal.type==="opp-view"&&<OpportunityForm initial={modal.rec} accountid={modal.rec.accountid} readOnly />}
          {modal&&modal.type==="referralsource-add"&&<ReferralSourceForm prefill={modal.prefill} hint={modal.hint} />}
          {modal&&modal.type==="referralsource-edit"&&<ReferralSourceForm initial={modal.rec} />}
          {modal&&modal.type==="referralsource-view"&&<ReferralSourceForm initial={modal.rec} readOnly />}
          {modal&&modal.type==="legalevent-add"&&<LegalEventForm accountid={modal.accountid} loanid={modal.loanid||null} />}
          {modal&&modal.type==="legalevent-edit"&&<LegalEventForm initial={modal.rec} accountid={modal.rec.accountid} loanid={modal.rec.loanid||null} />}
          {modal&&modal.type==="legalevent-view"&&<LegalEventForm initial={modal.rec} accountid={modal.rec.accountid} loanid={modal.rec.loanid||null} readOnly />}
          {modal&&modal.type==="chargeoff-add"&&<ChargeOffForm loanid={modal.loanid} />}
          {modal&&modal.type==="chargeoff-edit"&&<ChargeOffForm initial={modal.rec} loanid={modal.rec.loanid} />}
          {modal&&modal.type==="chargeoff-view"&&<ChargeOffForm initial={modal.rec} loanid={modal.rec.loanid} readOnly />}
          {modal&&modal.type==="contact-add"&&<ContactForm accountid={modal.accountid} initial={modal.initial} hint={modal.hint} />}
          {modal&&modal.type==="contact-edit"&&<ContactForm initial={modal.rec} accountid={modal.rec.accountid} />}
          {modal&&modal.type==="contact-view"&&<ContactForm initial={modal.rec} accountid={modal.rec.accountid} readOnly />}
          {modal&&modal.type==="riskrating-add"&&<RiskRatingForm loanid={modal.loanid} />}
          {modal&&modal.type==="riskrating-edit"&&<RiskRatingForm initial={modal.rec} loanid={modal.rec.loanid} />}
          {modal&&modal.type==="riskrating-view"&&<RiskRatingForm initial={modal.rec} loanid={modal.rec.loanid} readOnly />}
          {modal&&modal.type==="forward-rate-view"&&<ForwardRateForm key="view" initial={modal.rec} readOnly />}
          {modal&&modal.type==="forward-rate-add"&&<ForwardRateForm key="add" />}
          {modal&&modal.type==="forward-rate-edit"&&<ForwardRateForm key="edit" initial={modal.rec} readOnly={false} />}
          {modal&&modal.type==="pmtpostingrule-view"&&<PmtPostingRuleForm key="view" initial={modal.rec} readOnly />}
          {modal&&modal.type==="pmtpostingrule-add"&&<PmtPostingRuleForm key="add" />}
          {modal&&modal.type==="pmtpostingrule-edit"&&<PmtPostingRuleForm key="edit" initial={modal.rec} readOnly={false} />}
          {modal&&modal.type==="pspmt-add"&&<ParticipantSPmtForm loanid={modal.loanid} />}
          {modal&&modal.type==="pspmt-edit"&&<ParticipantSPmtForm initial={modal.rec} loanid={modal.rec.loanid} />}
          {modal&&modal.type==="pspmt-view"&&<ParticipantSPmtForm initial={modal.rec} loanid={modal.rec.loanid} readOnly />}
          {modal&&modal.type==="rate-add"&&<RateForm />}
          {modal&&modal.type==="rate-edit"&&<RateForm initial={modal.rec} />}
          {modal&&modal.type==="rate-view"&&<RateForm initial={modal.rec} readOnly />}
          {modal&&modal.type==="participantpmt-add"&&<ParticipantPmtForm loanid={modal.loanid} participantscheduledpmtid={modal.participantscheduledpmtid} />}
          {modal&&modal.type==="participantpmt-edit"&&<ParticipantPmtForm initial={modal.rec} loanid={modal.loanid} participantscheduledpmtid={modal.participantscheduledpmtid} />}
          {modal&&modal.type==="participantpmt-view"&&<ParticipantPmtForm initial={modal.rec} loanid={modal.loanid} participantscheduledpmtid={modal.participantscheduledpmtid} readOnly />}
          {modal&&modal.type==='interest-statement' && (<InterestStatementModal accountid={modal.accountid} companyname={modal.companyname} />)}
          {modal&&modal.type==='invoice'&&(<InvoiceModal accountid={modal.accountid} companyname={modal.companyname} />)}
          {modal&&modal.type==="fund-add"  && <FundForm />}
          {modal&&modal.type==="fund-edit" && <FundForm initial={modal.rec} />}
          {modal&&modal.type==="fund-view" && <FundForm initial={modal.rec} readOnly />}
          {modal&&modal.type==="loanfund-add"  && <LoanFundForm loanid={modal.loanid} />}
          {modal&&modal.type==="loanfund-edit" && <LoanFundForm initial={modal.rec} loanid={modal.loanid} />}
          {modal&&modal.type==="loanfund-view" && <LoanFundForm initial={modal.rec} loanid={modal.loanid} readOnly />}
          {modal&&modal.type==="collateral-entry" && (<CollateralSpreadsheet headerId={modal.headerId} loanid={modal.loanid} prefill={modal.prefill} onDone={modal.onDone}/> )}
          {modal&&modal.type==="covenantcatalog-add"&&<CovenantCatalogForm />}
          {modal&&modal.type==="covenantcatalog-edit"&&<CovenantCatalogForm initial={modal.rec} />}
          {modal&&modal.type==="covenantcatalog-view"&&<CovenantCatalogForm initial={modal.rec} readOnly />}
          {modal&&modal.type==="covenant-add"&&<CovenantForm accountid={modal.accountid} accountFundingDate={modal.accountFundingDate} accountMaturityDate={modal.accountMaturityDate} />}
          {modal&&modal.type==="covenant-edit"&&<CovenantForm initial={modal.rec} accountid={modal.rec.accountid} accountFundingDate={modal.accountFundingDate} accountMaturityDate={modal.accountMaturityDate} />}
          {modal&&modal.type==="covenant-view"&&<CovenantForm initial={modal.rec} accountid={modal.rec.accountid} accountFundingDate={modal.accountFundingDate} accountMaturityDate={modal.accountMaturityDate} readOnly />}
          {modal&&modal.type==="covenantcalendar-edit"&&<CovenantCalendarForm initial={modal.rec} />}
          {modal&&modal.type==="covenantcalendar-view"&&<CovenantCalendarForm initial={modal.rec} readOnly />}
          {modal&& (modal.type === "note-view" || modal.type === "note-edit") &&  <NoteForm initial={modal.rec} readOnly={modal.type === "note-view"} />}
          {modal&&modal.type==="bidashboard-add"&&<BIDashboardForm />}
          {modal&&modal.type==="bidashboard-edit"&&<BIDashboardForm initial={modal.rec} />}
          {modal&&modal.type==="bidashboard-view"&&<BIDashboardForm initial={modal.rec} readOnly />}
          {modal&&modal.type==="borrowerguarantor-add"&&<BorrowerGuarantorForm accountid={modal.accountid} />}
          {modal&&modal.type==="borrowerguarantor-edit"&&<BorrowerGuarantorForm initial={modal.rec} accountid={modal.rec.accountid} />}
          {modal&&modal.type==="borrowerguarantor-view"&&<BorrowerGuarantorForm initial={modal.rec} accountid={modal.rec.accountid} readOnly />}
          {modal&&modal.type==="bankaccount-add"&&<BankAccountForm accountid={modal.accountid} />}
          {modal&&modal.type==="bankaccount-edit"&&<BankAccountForm initial={modal.rec} accountid={modal.rec.accountid} wide />}
          {modal&&modal.type==="bankaccount-view"&&<BankAccountForm initial={modal.rec} accountid={modal.rec.accountid} wide readOnly />}
          {modal&&modal.type==="checklistcatalog-add"&&<ChecklistCatalogForm />}
          {modal&&modal.type==="checklistcatalog-edit"&&<ChecklistCatalogForm initial={modal.rec} />}
          {modal&&modal.type==="checklistcatalog-view"&&<ChecklistCatalogForm initial={modal.rec} readOnly />}
          {modal&&modal.type==="checklistitem-edit"&&<ChecklistItemForm initial={modal.rec} />}
          {modal&&modal.type==="checklistitem-view"&&<ChecklistItemForm initial={modal.rec} readOnly />}


          {confirm&&<Confirm msg={confirm.msg} title={confirm.title} confirmLabel={confirm.confirmLabel} variant={confirm.variant} acknowledge={confirm.acknowledge} onConfirm={confirm.onConfirm} onCancel={()=>setConfirm(null)} />}

          {view.page==="dashboard"&&<DashboardPage />}
          {view.page==="action-center"&&<ActionCenterPage />}
          {view.page==="overdue-payments"&&<OverduePaymentsPage />}
          {view.page==="owed-payments"&&<OwedPaymentsPage />}
          {view.page==="accounts"&&<AccountsPage />}
          {view.page==="account"&&<AccountPage />}
          {view.page==="loan"&&<LoanPage />}
          {view.page==="spmt"&&<SPmtPage />}
          {view.page==="all-loans"&&<AllLoansPage fundname={view.fundname} />}
          {view.page==="all-terms"&&<AllTermsPage />}
          {view.page==="all-draws"&&<AllDrawsPage />}
          {view.page==="all-spmts"&&<AllSpmtsPage />}
          {view.page==="all-achcollections"&&<AllACHCollectionsPage />}
          {view.page==="all-rpmts"&&<AllRpmtsPage />}
          {view.page==="all-participant-spmts"&&<AllParticipantSpmtsPage />}
          {view.page==="all-participant-pmts"&&<AllParticipantPmtsPage />}
          {view.page==="all-wftransactions"&&<AllWFTransactionsPage />}
          {view.page==="all-contacts"&&<AllContactsPage />}
          {view.page==="all-legal"&&<AllLegalEventsPage />}
          {view.page==="ucc-register"&&role.canViewMonitoring&&<UCCRegisterPage />}
          {view.page==="ucc-searches"&&role.canViewMonitoring&&<UCCSearchesPage />}
          {view.page==="tax-monitoring"&&role.canViewMonitoring&&<TaxMonitoringPage />}
          {view.page==="news-monitor"&&role.canViewMonitoring&&<NewsMonitorPage />}
          {view.page==="mca-monitor"&&role.canViewBankFeeds&&<MCAMonitorPage />}
          {view.page==="bank-activity"&&role.canViewBankFeeds&&<BankActivityPage />}
          {view.page==="all-mcacompanies"&&<MCACompaniesPage />}
          {view.page==="taxguard-matching"&&role.canViewMonitoring&&<TaxGuardMatchingPage />}
          {view.page==="all-chargeoffs"&&<AllChargeOffsPage  />}
          {view.page==="all-riskratings"&&<AllRiskRatingsPage  />}
          {view.page==="all-rates"&&<AllRatesPage />}
          {view.page==="all-forwardrates"&&<AllForwardRatesPage />}
          {view.page==="all-pmtpostingrules"&&role.isAdmin&&<AllPmtPostingRulesPage />}
          {view.page==="all-notes" && <AllNotesPage />}
          {view.page==="reports"&&<ReportBuilderPage />}
          {view.page=== "all-funds" && role.canManageUsers && <AllFundsPage />}
          {view.page==="usage"&&role.isAdmin&&<UsagePage />}
          {view.page==="audit"&&role.isAdmin&&<><SectionHeader title="Audit log" /><AuthContext.Provider value={{ api }}><AuditViewer /></AuthContext.Provider></>}
          {view.page==="all-statements"&&role.isservicer&&<InterestStatementBatchPage />}
          {view.page==="publish-statements"&&(role.isservicer||role.isAdmin)&&<PublishStatementsPage />}
          {view.page==="client-invoice-notices"&&role.canManageUsers&&<ClientInvoiceNoticesPage />}
          {view.page==="bank-mapping"&&(role.isservicer||role.isAdmin)&&<BankAccountMappingPage />}
          {view.page==="client-bank-detail"&&<ClientBankDetailPage />}
          {view.page==="data-model"&&role.canManageUsers&&<DataModelPage />}
          {view.page==="update-scheduled-payments"&&role.isservicer&&<UpdateScheduledPaymentsPage />}
          {view.page==="invoice-batch"&&role.isservicer&&<InvoiceBatchPage />}
          {view.page==="all-covenants"&&<CovenantsPage />}
          {view.page==="all-covenant-calendar"&&<CovenantCalendarPage />}
          {view.page==="all-covenant-catalog"&&role.canManageUsers&&<CovenantCatalogPage />}
          {view.page==="all-bi-dashboards"&&role.canManageUsers&&<PowerBIDashboardsPage />}
          {view.page==="collateral-analytics"&&<CollateralAnalyticsPage />}
          {view.page==="draw-forecast"&&<DrawForecastPage />}
          {view.page==="stratification"&&<StratificationPage />}
          {view.page==="portfolio-balance"&&<PortfolioBalancePage />}
          {view.page==="portfolio-performance"&&<PortfolioPerformancePage />}
          {view.page==="forward-curves"&&<ForwardCurvesPage />}
          {view.page==="industry-closings"&&<IndustryClosingsPage />}
          {view.page==="bank-transactions"&&role.isAdmin&&<BankTransactionsPage />}
          {view.page==="bank-import"&&(role.isservicer||role.isAdmin)&&<BankImportPage />}
          {view.page==="integration-wf" && role.canManageUsers && <IntegrationWFPage />}
          {view.page==="integration-plaid" && role.canManageUsers && <IntegrationPlaidPage />}
          {view.page==="all-bankaccounts"&&<AllBankAccountsPage />}
          {view.page==="all-borrowersguarantors"&&<AllBorrowersGuarantorsPage />}
          {view.page==="all-covenant-calendar-visual"&&<CovenantCalendarVisual />}
          {view.page?.startsWith("bi:")&&<BIDashboardPage id={view.page.slice(3)} />}
          {view.page==="all-checklist-catalog"&&role.canManageUsers&&<ChecklistCatalogPage />}
          {view.page==="all-checklist-mapping"&&role.canManageUsers&&<ChecklistMappingPage />}
          {view.page==="all-checklist"&&<AllChecklistPage />}
          {view.page==="covenant-exceptions"&&<AllCovenantExceptionsPage  />}
          {view.page==="sales-dashboard"&&role.canAccessSales&&<SalesDashboardPage />}
          {view.page==="sales-followups"&&role.canAccessSales&&<FollowUpsPage />}
          {view.page==="sales-leads"&&role.canAccessSales&&<LeadsPage />}
          {view.page==="sales-accounts"&&role.canAccessSales&&<SalesAccountsPage />}
          {view.page==="sales-account"&&role.canAccessSales&&<SalesAccountPage />}
          {view.page==="sales-opportunities"&&role.canAccessSales&&<OpportunitiesPage />}
          {/* The Pipeline board now lives on the Sales Dashboard; old links land there. */}
          {view.page==="sales-pipeline"&&role.canAccessSales&&<SalesDashboardPage />}
          {view.page==="sales-analytics"&&role.canAccessSales&&<SalesAnalyticsPage />}
          {view.page==="sales-opportunity-sources"&&role.canAccessSales&&<OpportunitySourcesPage />}
          {view.page==="sales-fallout"&&role.canAccessSales&&<FalloutAnalysisPage />}
          {view.page==="sales-by-employee"&&role.canAccessSales&&<EmployeeSummaryPage />}
          {view.page==="sales-monthly-activity"&&role.canAccessSales&&<MonthlyActivityPage />}
          {view.page==="sales-leads-by-month"&&role.canAccessSales&&<LeadsByMonthPage />}
          {view.page==="sales-lead-to-opp"&&role.canAccessSales&&<LeadToOpportunityPage />}
          {view.page==="sales-opp-to-ts"&&role.canAccessSales&&<OpportunityToTermSheetPage />}
          {view.page==="sales-opp-by-month"&&role.canAccessSales&&<OpportunityByMonthPage />}
          {view.page==="sales-ts-to-funding"&&role.canAccessSales&&<TermSheetToFundingPage />}
          {view.page==="sales-ts-signed-funding"&&role.canAccessSales&&<TSSignedToFundingPage />}
          {view.page==="sales-opp-ts-month"&&role.canAccessSales&&<OppTSByMonthPage />}
          {view.page==="sales-fallout-detail"&&role.canAccessSales&&<FalloutDetailPage />}
          {view.page==="sales-contacts"&&role.canAccessSales&&<SalesContactsPage />}
          {view.page==="sales-email-triage"&&role.canAccessSales&&<EmailTriagePage />}
          {view.page==="integration-m365mail"&&role.canManageUsers&&<MailCaptureAdminPage />}
          {view.page==="integration-notifications"&&role.canManageUsers&&<IntegrationNotificationsPage />}
          {view.page==="integration-clientmail"&&role.canManageUsers&&<IntegrationClientMailPage />}
          {view.page==="integration-csc"&&role.canManageUsers&&<IntegrationCSCPage />}
          {view.page==="integration-taxguard"&&role.canManageUsers&&<IntegrationTaxGuardPage />}
          {view.page==="integration-news"&&role.canManageUsers&&<IntegrationSerperPage />}
          {view.page==="sales-referral-sources"&&role.canAccessSales&&<ReferralSourcesPage />}
          {view.page==="referral-source"&&role.canAccessSales&&<ReferralSourcePage />}
          {view.page==="collateral-portfolio" && <CollateralPortfolio/>}
          {view.page==="collateral-dashboard" && <CollateralDashboard/>}
          {view.page==="collateral-home" && <CollateralHome/>}
          {view.page==="collateral-bbc" && <BorrowingBaseDetail/>}
          {view.page==="collateral-insights" && <CollateralInsights/>}
          {view.page==="users"&&role.canManageUsers&&<UserManagementPage />}
          {view.page==="client-portal"&&role.canManageUsers&&<ClientPortalPage />}
        </div>
      </div>
    </AuthContext.Provider>
    </AppContext.Provider>
  );
}